"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9805],{

/***/ 3914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Outdoor_Outdoor; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Outdoor/Outdoor.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;




var Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs({
  alignItems: 'center',
  flexDirection: 'column'
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 30px 5px;\n  background-color: ", ";\n  justify-content: center;\n"])), function (props) {
  return (0,build_esm.getPaletteColor)('background.lighter')(props);
});
var Image = styled_components_browser_esm["default"].img(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 20px 0;\n"])));
var Label = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return {
    color: props.color || 'text.base',
    fontSize: props.fontSize || 1,
    fontWeight: props.fontWeight || 'regular'
  };
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.58;\n  letter-spacing: normal;\n  text-align: center;\n  text-transform: ", ";\n  width: ", ";\n"])), function (props) {
  return props.textTransform || 'none';
}, function (props) {
  return props.width || '100%';
});
var Link = styled_components_browser_esm["default"].a(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: ", ";\n  font-size: ", "px;\n  text-transform: uppercase;\n  color: ", ";\n  width: 238px;\n  height: 40px;\n  border-radius: 20px;\n  background-color: ", ";\n  cursor: pointer;\n  margin-top: 10px;\n"])), function (props) {
  return (0,build_esm.themeGet)('fontWeights.regular')(props);
}, function (props) {
  return (0,build_esm.themeGet)('fontSizes.0')(props);
}, function (props) {
  return (0,build_esm.getTextColor)('lightest')(props);
}, function (props) {
  return (0,build_esm.getPaletteColor)('primary.base')(props);
});
var Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return {
    color: props.color || 'primary.base',
    fontSize: props.fontSize || 8,
    fontWeight: props.fontWeight || 'bold'
  };
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Outdoor/Outdoor.js





var Outdoor = function Outdoor(_ref) {
  var staticProps = _ref["static"];
  var title = staticProps.title,
    content = staticProps.content,
    button = staticProps.button;
  return react.createElement(Container, {
    "data-testid": "outdoor"
  }, !!Object.keys(title).length && react.createElement(Title, title.layout || {}, title.text), content && content.map(function (line) {
    if (typeof line === 'string') {
      return react.createElement(Label, {
        key: "outdoor-".concat(line)
      }, line);
    }
    if (line.img) {
      return react.createElement(Image, {
        key: "outdoor-".concat(line.img),
        src: line.img,
        alt: line.alt
      });
    }
    return react.createElement(Label, (0,esm_extends/* default */.Z)({}, line.layout || {}, {
      key: "outdoor-".concat(line.text)
    }), line.ellipsis ? (0,esm/* textEllipsis */.vS)(line.text, line.ellipsis) : line.text);
  }), !!Object.keys(button).length && react.createElement(Link, (0,esm_extends/* default */.Z)({
    href: button.href
  }, button.layout || {}), button.text));
};
Outdoor.defaultProps = {
  "static": {
    button: {},
    content: [],
    title: {}
  }
};
 false ? 0 : void 0;
Outdoor.ssr = true;
/* harmony default export */ var Outdoor_Outdoor = (Outdoor);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Outdoor/index.js


/***/ }),

/***/ 9401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ pagination; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Pagination/index.js + 3 modules
var molecules_Pagination = __webpack_require__(19620);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Pagination/pagination.js






var Pagination = function Pagination(_ref) {
  var structure = _ref.structure,
    staticProps = _ref["static"];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var canonicalPath = structure.canonicalPath,
    query = structure.query;
  var _onChange = function onChange(e, page) {
    e.preventDefault();
    publish('paginate:click', {
      eventLabel: page
    });
    var path = (0,esm/* getCurrentPath */.Jz)({
      page: page
    });
    (0,esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var _ref2 = staticProps || {},
    pagination = _ref2.pagination;
  var currentPage = query.page;
  return react.createElement(molecules_Pagination/* default */.Z, {
    count: pagination == null ? void 0 : pagination.pages,
    page: (0,esm/* parsePageFilter */.iz)(currentPage),
    path: canonicalPath,
    onChange: function onChange(e, page) {
      return _onChange(e, page);
    }
  });
};
 false ? 0 : void 0;
Pagination.defaultProps = {
  "static": {},
  structure: {}
};
Pagination.ssr = true;
/* harmony default export */ var pagination = ((0,withLayoutProps/* default */.Z)(Pagination));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Pagination/index.js


/***/ }),

/***/ 45760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ panel; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Panel/styles.js

var _templateObject;

var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  min-width: 100px;\n  min-height: 100px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Panel/panel.js

var _excluded = ["children"];



function Panel(_ref) {
  var children = _ref.children,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  return react.createElement(Container, props, children);
}
Panel.ssr = true;
/* harmony default export */ var panel = ((0,withLayoutProps/* default */.Z)(Panel));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Panel/index.js


/***/ }),

/***/ 20451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PaymentMethods_PaymentMethods; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/index.js + 5 modules
var molecules_PaymentMethods = __webpack_require__(563);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/index.js + 1 modules
var VisibilitySection = __webpack_require__(17322);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PaymentMethods/PaymentMethods.utils.js
var paymentTypes = {
  boleto: 'bankSlip',
  luiza_ouro: 'luizaCard',
  pix: 'pix',
  visa: 'creditCard'
};
var mapPaymentMethods = function mapPaymentMethods() {
  var paymentMethods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return paymentMethods.reduce(function (acc, payment) {
    var paymentKey = paymentTypes[payment.id] || 'creditCard';
    acc[paymentKey] = payment;
    return acc;
  }, {});
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PaymentMethods/PaymentMethods.js


var _excluded = ["asTab", "title", "marginBottomScroll"];









var PaymentMethods = function PaymentMethods(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    layout = _ref.layout,
    onEvent = _ref.onEvent;
  var elemRef = (0,react.useRef)(null);
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe,
    publish = _usePublisher.publish;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    _ref2$paymentMethods = _ref2.paymentMethods,
    paymentMethods = _ref2$paymentMethods === void 0 ? [] : _ref2$paymentMethods;
  var paymentsById = mapPaymentMethods(paymentMethods);
  var handlePaymentMethodChange = function handlePaymentMethodChange(_ref3) {
    var id = _ref3.id;
    publish('product:paymentmethod:change', {
      paymentId: id
    });
  };
  var asTab = staticProps.asTab,
    title = staticProps.title,
    marginBottomScroll = staticProps.marginBottomScroll,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var handlePaymentMethodClick = function handlePaymentMethodClick() {
    return onEvent ? onEvent() : (0,build_esm/* scrollToRef */.BC)(elemRef, marginBottomScroll);
  };
  (0,react.useEffect)(function () {
    subscribe('product:paymentmethod:click', handlePaymentMethodClick);
    return function () {
      unsubscribe('product:paymentmethod:click', handlePaymentMethodClick);
    };
  });
  return !!paymentMethods.length && react.createElement(VisibilitySection/* default */.Z, {
    eventKey: "product:active:section",
    eventValue: "product:paymentmethod"
  }, react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "payment-methods",
    mb: 3
  }, props, layout, {
    ref: elemRef,
    yOffset: marginBottomScroll
  }), title && react.createElement(Heading/* default */.Z, {
    "data-testid": "payment-methods-title",
    as: "h2",
    color: "base",
    fontSize: 5,
    fontWeight: "medium",
    my: [2, 2, 3, 3]
  }, title), react.createElement(molecules_PaymentMethods/* default */.Z, {
    asTab: asTab,
    payments: paymentsById,
    onChange: handlePaymentMethodChange
  })));
};
 false ? 0 : void 0;
PaymentMethods.defaultProps = {
  data: {},
  layout: {},
  onEvent: undefined,
  "static": {
    asTab: true
  }
};
PaymentMethods.ssr = true;
PaymentMethods.dataSource = {
  product: {
    fragments: ['showPayment'],
    query: 'ProductQuery'
  }
};
/* harmony default export */ var PaymentMethods_PaymentMethods = (PaymentMethods);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PaymentMethods/index.js


/***/ }),

/***/ 20347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PercycleProductCarousel_PercycleProductCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PercycleProductCarousel/hook/parsePercycleWidgets.js

var parseWidgetData = function parseWidgetData(product, position) {
  var _product$customFields, _product$customFields2, _product$customFields3, _product$customFields4, _product$categories, _product$installment, _product$installment$, _product$installment2, _product$installment3, _product$installment4, _product$installment5, _product$installment6, _product$salePrice, _product$discount, _product$price, _product$customFields5, _product$customFields6, _product$customFields7, _product$customFields8, _product$categories2;
  return {
    available: true,
    brand: {
      label: product.brand,
      slug: (0,build_esm/* slug */.oF)(product.brand)
    },
    category: {
      id: (_product$customFields = product.customFields) == null ? void 0 : (_product$customFields2 = _product$customFields.categoriesId) == null ? void 0 : (_product$customFields3 = _product$customFields2.split('/')) == null ? void 0 : (_product$customFields4 = _product$customFields3[0]) == null ? void 0 : _product$customFields4.toUpperCase(),
      name: (_product$categories = product.categories) == null ? void 0 : _product$categories[0]
    },
    id: product.id,
    image: product.imageLink,
    installment: {
      amount: (_product$installment = product.installment) == null ? void 0 : (_product$installment$ = _product$installment.amount) == null ? void 0 : _product$installment$.value,
      paymentMethodDescription: ((_product$installment2 = product.installment) == null ? void 0 : _product$installment2.paymentMethodDescription) || '',
      quantity: (_product$installment3 = product.installment) == null ? void 0 : _product$installment3.months,
      totalAmount: (((_product$installment4 = product.installment) == null ? void 0 : _product$installment4.months) * Number((_product$installment5 = product.installment) == null ? void 0 : (_product$installment6 = _product$installment5.amount) == null ? void 0 : _product$installment6.value)).toFixed(2)
    },
    origin: 'percycle',
    position: position,
    price: {
      bestPrice: (_product$salePrice = product.salePrice) == null ? void 0 : _product$salePrice.value,
      discount: product == null ? void 0 : (_product$discount = product.discount) == null ? void 0 : _product$discount.value,
      price: (_product$price = product.price) == null ? void 0 : _product$price.value
    },
    px: product.px,
    seller: {
      category: product.seller === 'magazineluiza' ? '1p' : '3p',
      id: product.seller
    },
    subcategory: {
      id: (_product$customFields5 = product.customFields) == null ? void 0 : (_product$customFields6 = _product$customFields5.categoriesId) == null ? void 0 : (_product$customFields7 = _product$customFields6.split('/')) == null ? void 0 : (_product$customFields8 = _product$customFields7[1]) == null ? void 0 : _product$customFields8.toUpperCase(),
      name: (_product$categories2 = product.categories) == null ? void 0 : _product$categories2[1]
    },
    title: product.title,
    url: product.link
  };
};
var parsePercycleWidgets = function parsePercycleWidgets(widgets) {
  return widgets == null ? void 0 : widgets.map(function (_ref) {
    var widget = _ref.widget,
      px = _ref.px,
      data = _ref.data;
    return {
      data: data == null ? void 0 : data.map(function (product, position) {
        return parseWidgetData(product, position + 1);
      }),
      px: px,
      widget: widget
    };
  });
};
/* harmony default export */ var hook_parsePercycleWidgets = (parsePercycleWidgets);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PercycleProductCarousel/hook/usePercycle.js




var _excluded = ["widgets", "types", "productTypes", "placement", "customPlacements", "categories", "id"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }



var joinIfArray = function joinIfArray(data, separator) {
  return Array.isArray(data) ? data.filter(Boolean).join(separator) : data;
};
var usePercycle = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(_ref) {
    var widgets, types, productTypes, placement, customPlacements, categories, id, customParams, _getConfig, publicRuntimeConfig, _publicRuntimeConfig$, host, token, percycleURL, response, _yield$response$json, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          widgets = _ref.widgets, types = _ref.types, productTypes = _ref.productTypes, placement = _ref.placement, customPlacements = _ref.customPlacements, categories = _ref.categories, id = _ref.id, customParams = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
          if (!build_esm/* whereAmI.onServer */.er.onServer) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", []);
        case 3:
          _getConfig = config_default()(), publicRuntimeConfig = _getConfig.publicRuntimeConfig;
          _publicRuntimeConfig$ = publicRuntimeConfig == null ? void 0 : publicRuntimeConfig.percycle, host = _publicRuntimeConfig$.host, token = _publicRuntimeConfig$.token;
          percycleURL = new URL(host);
          percycleURL.search = new URLSearchParams((0,esm_extends/* default */.Z)({
            categories: joinIfArray(categories, '>'),
            custom_placements: joinIfArray(customPlacements, ','),
            hash: token,
            id: id,
            placement: joinIfArray(placement, ','),
            productTypes: joinIfArray(productTypes, ','),
            types: joinIfArray(types, ','),
            widgets: joinIfArray(widgets, ',')
          }, customParams));
          _context.prev = 7;
          _context.next = 10;
          return fetch(percycleURL);
        case 10:
          response = _context.sent;
          if (response.ok) {
            _context.next = 13;
            break;
          }
          throw new Error("percycle request failed for ".concat(percycleURL, " with status: ").concat(response.status, " ").concat(response.statusText));
        case 13:
          _context.next = 15;
          return response.json();
        case 15:
          _yield$response$json = _context.sent;
          data = _yield$response$json.data;
          return _context.abrupt("return", hook_parsePercycleWidgets(data));
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](7);
          console.error("[usePercycle] - error: ".concat(_context.t0));
          return _context.abrupt("return", []);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 20]]);
  }));
  return function usePercycle(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/* harmony default export */ var hook_usePercycle = (usePercycle);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PercycleProductCarousel/hook/buildCustomParams.js

var buildCommonParams = function buildCommonParams(_ref) {
  var _structure$route, _data$search, _data$search$products, _data$search2, _data$search2$product;
  var structure = _ref.structure,
    data = _ref.data;
  return {
    searchPage: ((_structure$route = structure.route) == null ? void 0 : _structure$route.page) || 1,
    searchProducts: (_data$search = data.search) == null ? void 0 : (_data$search$products = _data$search.products) == null ? void 0 : _data$search$products.map(function (_ref2) {
      var variationId = _ref2.variationId;
      return variationId;
    }).join(','),
    searchResults: ((_data$search2 = data.search) == null ? void 0 : (_data$search2$product = _data$search2.products) == null ? void 0 : _data$search2$product.length) || 0
  };
};
var buildCustomParams = function buildCustomParams(_ref3) {
  var _structure$route2, _structure$route3;
  var type = _ref3.type,
    _ref3$structure = _ref3.structure,
    structure = _ref3$structure === void 0 ? {} : _ref3$structure,
    _ref3$data = _ref3.data,
    data = _ref3$data === void 0 ? {} : _ref3$data;
  var customParam = {
    search: (0,esm_extends/* default */.Z)({
      search: "".concat((_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term)
    }, buildCommonParams({
      data: data,
      structure: structure
    })),
    selection: (0,esm_extends/* default */.Z)({
      search: "LANDING PAGE: ".concat((_structure$route3 = structure.route) == null ? void 0 : _structure$route3.selectionId)
    }, buildCommonParams({
      data: data,
      structure: structure
    }))
  };
  return customParam[type || structure.id] || {};
};
/* harmony default export */ var hook_buildCustomParams = (buildCustomParams);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PercycleProductCarousel/PercycleProductCarousel.styles.js

var _templateObject, _templateObject2;


var Container = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var PixelContainer = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: none;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PercycleProductCarousel/PercycleProductCarousel.js






var PercycleProductCarousel_excluded = ["auto", "imageAltPrefix", "listPosition", "page", "placement", "productTitleAs", "productTypes", "showArrowControls", "showControls", "showDiscount", "showDiscountOnlyCashInfo", "showInCashInfo", "showPartialNextSlide", "slidesPerView", "title", "titleAs", "types", "widgets"];
function PercycleProductCarousel_regeneratorRuntime() { "use strict"; PercycleProductCarousel_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }











var PercycleProductCarousel = function PercycleProductCarousel(_ref) {
  var _product$category, _product$subcategory, _structure$cookies, _structure$cookies$ac, _structure$route2, _structure$route3;
  var staticProps = _ref["static"],
    structure = _ref.structure,
    data = _ref.data;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var product = data.product;
  var _structure$route = structure.route,
    _structure$route$prod = _structure$route.productId,
    productId = _structure$route$prod === void 0 ? '' : _structure$route$prod,
    _structure$route$cate = _structure$route.categorySlug,
    categorySlug = _structure$route$cate === void 0 ? (0,build_esm/* slug */.oF)(product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.name) : _structure$route$cate,
    _structure$route$subC = _structure$route.subCategorySlug,
    subCategorySlug = _structure$route$subC === void 0 ? (0,build_esm/* slug */.oF)(product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.name) : _structure$route$subC;
  var _staticProps$auto = staticProps.auto,
    auto = _staticProps$auto === void 0 ? true : _staticProps$auto,
    _staticProps$imageAlt = staticProps.imageAltPrefix,
    imageAltPrefix = _staticProps$imageAlt === void 0 ? 'Imagem de ' : _staticProps$imageAlt,
    _staticProps$listPosi = staticProps.listPosition,
    listPosition = _staticProps$listPosi === void 0 ? 1 : _staticProps$listPosi,
    page = staticProps.page,
    placement = staticProps.placement,
    _staticProps$productT = staticProps.productTitleAs,
    productTitleAs = _staticProps$productT === void 0 ? 'h3' : _staticProps$productT,
    _staticProps$productT2 = staticProps.productTypes,
    productTypes = _staticProps$productT2 === void 0 ? 'all' : _staticProps$productT2,
    _staticProps$showArro = staticProps.showArrowControls,
    showArrowControls = _staticProps$showArro === void 0 ? false : _staticProps$showArro,
    _staticProps$showCont = staticProps.showControls,
    showControls = _staticProps$showCont === void 0 ? true : _staticProps$showCont,
    _staticProps$showDisc = staticProps.showDiscount,
    showDiscount = _staticProps$showDisc === void 0 ? false : _staticProps$showDisc,
    _staticProps$showDisc2 = staticProps.showDiscountOnlyCashInfo,
    showDiscountOnlyCashInfo = _staticProps$showDisc2 === void 0 ? false : _staticProps$showDisc2,
    _staticProps$showInCa = staticProps.showInCashInfo,
    showInCashInfo = _staticProps$showInCa === void 0 ? false : _staticProps$showInCa,
    _staticProps$showPart = staticProps.showPartialNextSlide,
    showPartialNextSlide = _staticProps$showPart === void 0 ? true : _staticProps$showPart,
    _staticProps$slidesPe = staticProps.slidesPerView,
    slidesPerView = _staticProps$slidesPe === void 0 ? 3 : _staticProps$slidesPe,
    title = staticProps.title,
    _staticProps$titleAs = staticProps.titleAs,
    titleAs = _staticProps$titleAs === void 0 ? 'h2' : _staticProps$titleAs,
    _staticProps$types = staticProps.types,
    types = _staticProps$types === void 0 ? 'native' : _staticProps$types,
    _staticProps$widgets = staticProps.widgets,
    widgetsParam = _staticProps$widgets === void 0 ? ['native', '24_all'] : _staticProps$widgets,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, PercycleProductCarousel_excluded);
  var categories = [categorySlug, subCategorySlug].filter(Boolean).join(' > ');
  var showcase = {
    pageId: page,
    placeId: placement,
    title: title,
    type: 'carousel'
  };
  var _useState = (0,react.useState)([]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    activeItems = _useState2[0],
    setActiveItems = _useState2[1];
  var _useState3 = (0,react.useState)([]),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    widgets = _useState4[0],
    setWidgets = _useState4[1];
  var _useState5 = (0,react.useState)([]),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    viewedPixel = _useState6[0],
    setViewedPixel = _useState6[1];
  var eventData = {
    customer_id: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id,
    display: 'galeria',
    filters: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.filters,
    list: title,
    listPosition: listPosition,
    origin: 'percycle',
    pageName: structure == null ? void 0 : structure.name,
    showcase: showcase,
    term: structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.term,
    type: 'recomendacao'
  };
  var handleProductClick = (0,react.useCallback)(function (_e, clickedProduct) {
    var _structure$route4;
    publish('productlist:selectItem:click', (0,esm_extends/* default */.Z)({}, eventData, clickedProduct));
    publish('productlist:click', (0,esm_extends/* default */.Z)({}, clickedProduct, {
      display: 'galeria',
      filters: structure == null ? void 0 : (_structure$route4 = structure.route) == null ? void 0 : _structure$route4.filters,
      list: title,
      listPosition: listPosition,
      origin: 'percycle',
      showcase: showcase,
      type: 'recomendacao'
    }));
  }, [title, listPosition, showcase]);
  var getPercycleWidgets = (0,react.useCallback)((0,asyncToGenerator/* default */.Z)(PercycleProductCarousel_regeneratorRuntime().mark(function _callee() {
    var percycleParams, response;
    return PercycleProductCarousel_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          percycleParams = (0,esm_extends/* default */.Z)({
            categories: categories,
            customPlacements: page,
            id: productId,
            placement: placement,
            productTypes: productTypes,
            types: types,
            widgets: widgetsParam
          }, hook_buildCustomParams({
            data: data,
            structure: structure,
            type: structure.route.id
          }));
          _context.next = 3;
          return hook_usePercycle(percycleParams);
        case 3:
          response = _context.sent;
          setWidgets(Array.isArray(response) ? response : []);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [placement, page, categories, productId]);
  var updatePercycleViewedWidget = (0,react.useCallback)(function () {
    var activeProductPixel = activeItems.map(function (item) {
      return item == null ? void 0 : item.px;
    });
    var pixels = [].concat((0,toConsumableArray/* default */.Z)(widgets == null ? void 0 : widgets.map(function (_ref3) {
      var px = _ref3.px;
      return px;
    })), (0,toConsumableArray/* default */.Z)(activeProductPixel)).filter(Boolean);
    var uniqueViewed = new Set([].concat((0,toConsumableArray/* default */.Z)(viewedPixel), (0,toConsumableArray/* default */.Z)(pixels)));
    setViewedPixel((0,toConsumableArray/* default */.Z)(uniqueViewed));
  }, [activeItems]);
  (0,react.useEffect)(function () {
    getPercycleWidgets();
    return function () {
      setWidgets([]);
    };
  }, []);
  (0,react.useLayoutEffect)(function () {
    updatePercycleViewedWidget();
    return function () {
      setViewedPixel([]);
    };
  }, [activeItems]);
  (0,react.useEffect)(function () {
    if (widgets) {
      widgets.forEach(function (widget, index) {
        var _widget$data;
        if (widget == null ? void 0 : (_widget$data = widget.data) == null ? void 0 : _widget$data.length) {
          var _structure$route5;
          publish('productlist:impression', {
            display: 'gallery',
            filters: structure == null ? void 0 : (_structure$route5 = structure.route) == null ? void 0 : _structure$route5.filters,
            list: title,
            listPosition: listPosition + index,
            origin: 'percycle',
            products: widget.data,
            showcase: showcase,
            type: 'recomendacao'
          });
        }
      });
    }
  }, [widgets]);
  var handleProductView = function handleProductView(productData, index) {
    var _structure$route6;
    publish('product:view', {
      display: 'gallery',
      filters: structure == null ? void 0 : (_structure$route6 = structure.route) == null ? void 0 : _structure$route6.filters,
      list: title,
      listPosition: listPosition + index,
      origin: 'percycle',
      product: (0,esm_extends/* default */.Z)({}, productData, {
        position: productData.index + 1
      }),
      type: 'recomendacao'
    });
    publish('product:viewItemList', (0,esm_extends/* default */.Z)({}, eventData, productData));
  };
  return react.createElement(react.Fragment, null, (widgets == null ? void 0 : widgets.some(function (widget) {
    var _widget$data2;
    return !!(widget == null ? void 0 : (_widget$data2 = widget.data) == null ? void 0 : _widget$data2.length);
  })) && react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "percycle-container",
    m: "20px 0 25px"
  }, props), react.createElement(Heading/* default */.Z, {
    "data-testid": "percycle-title",
    color: "base",
    as: titleAs,
    fontSize: [2, 4, 5, 5],
    fontWeight: "medium",
    lineHeight: "display",
    m: "0 8px 12px"
  }, title), widgets.map(function (widget, index) {
    var _widget$data3;
    return !!(widget == null ? void 0 : (_widget$data3 = widget.data) == null ? void 0 : _widget$data3.length) && react.createElement(Grid/* default */.Z, {
      maxWidth: "100%",
      mb: 4
    }, react.createElement(ProductCarousel/* default */.Z, {
      gutter: 8,
      onChange: setActiveItems,
      onProductView: function onProductView(productData) {
        return handleProductView(productData, index);
      },
      onClick: handleProductClick,
      products: widget.data,
      productTitleAs: productTitleAs,
      imageAltPrefix: imageAltPrefix,
      auto: auto,
      showRating: false,
      showArrowControls: showArrowControls,
      showControls: showControls,
      slidesPerView: slidesPerView,
      showInCashInfo: showInCashInfo,
      showPartialNextSlide: showPartialNextSlide,
      showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
      showDiscount: showDiscount
    }));
  })), !!viewedPixel.length && react.createElement(PixelContainer, {
    "data-testid": "percycle-px"
  }, viewedPixel.map(function (px) {
    return react.createElement("img", {
      "data-testid": "percycle-px-img",
      key: px,
      src: px,
      alt: "native-pixel-home"
    });
  })));
};
PercycleProductCarousel.ssr = false;
PercycleProductCarousel.defaultProps = {
  "static": {}
};
 false ? 0 : void 0;
/* harmony default export */ var PercycleProductCarousel_PercycleProductCarousel = ((0,withLayoutProps/* default */.Z)(PercycleProductCarousel));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PercycleProductCarousel/index.js


/***/ }),

/***/ 11742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PopularDepartments_PopularDepartments; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PopularDepartments/PopularDepartments.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;




var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  overflow-x: auto;\n\n  ", " {\n    font-size: ", "px;\n    overflow-x: hidden;\n  }\n"])), (0,build_esm.getMediaQuery)('medium'), (0,build_esm.themeGet)('fontSizes.2'));
var Heading = (0,styled_components_browser_esm["default"])(atoms/* Heading */.X6)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  margin: 0 8px 30px;\n\n  ", " {\n    font-size: ", "px;\n  }\n"])), (0,build_esm.themeGet)('fontSizes.2'), (0,build_esm.getMediaQuery)('medium'), (0,build_esm.themeGet)('fontSizes.5'));
var Item = styled_components_browser_esm["default"].a(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0px 5px 0px 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n"])));
var ItemImg = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 150px;\n  background-color: ", ";\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.bgColor;
}, function (_ref) {
  var imageWidth = _ref.imageWidth;
  return imageWidth || '90px';
}, function (_ref2) {
  var imageHeight = _ref2.imageHeight;
  return imageHeight || '90px';
});
var ItemLabel = styled_components_browser_esm["default"].p(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 15px;\n  text-align: center;\n  width: 90px;\n  line-height: ", ";\n  color: ", ";\n"])), function (props) {
  return (0,build_esm.themeGet)('lineHeights.display')(props);
}, function (props) {
  return (0,build_esm.getTextColor)('base')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PopularDepartments/PopularDepartments.js





var PopularDepartments = function PopularDepartments(_ref) {
  var staticProps = _ref["static"];
  var items = staticProps.items,
    title = staticProps.title;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleItemClick = function handleItemClick(_ref2) {
    var index = _ref2.index,
      text = _ref2.text;
    publish('product:selectPromotion', {
      index: index,
      text: text
    });
    publish('search:popularDepartaments:click', {
      text: text
    });
  };
  var renderItems = function renderItems() {
    return items.map(function (_ref3, index) {
      var _ref3$link = _ref3.link,
        text = _ref3$link.text,
        href = _ref3$link.href,
        _ref3$image = _ref3.image,
        _ref3$image$src = _ref3$image.src,
        src = _ref3$image$src === void 0 ? '' : _ref3$image$src,
        alt = _ref3$image.alt,
        imageWidth = _ref3$image.imageWidth,
        imageHeight = _ref3$image.imageHeight,
        id = _ref3.id;
      publish('product:viewPromotion', {
        index: index,
        text: text
      });
      var imageIms = "".concat(imageWidth !== null && imageWidth !== void 0 ? imageWidth : '90', "x").concat(imageHeight !== null && imageHeight !== void 0 ? imageHeight : '90');
      var imageSrc = "".concat(src, "?ims=").concat(imageIms.replace(/px/gi, ''));
      return react.createElement(Item, {
        key: id,
        onClick: function onClick() {
          return handleItemClick({
            index: index,
            text: text
          });
        },
        href: href,
        "data-testid": "item-popular-departments"
      }, react.createElement(ItemImg, {
        alt: alt,
        src: imageSrc,
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        lazy: true
      }), react.createElement(ItemLabel, null, text));
    });
  };
  return react.createElement(react.Fragment, null, react.createElement(Heading, {
    "data-testid": "popular-departments-title",
    as: "h2"
  }, title), react.createElement(Container, null, renderItems()));
};
PopularDepartments.defaultProps = {
  "static": {
    items: []
  }
};
 false ? 0 : void 0;
PopularDepartments.ssr = true;
/* harmony default export */ var PopularDepartments_PopularDepartments = ((0,withLayoutProps/* default */.Z)(PopularDepartments));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PopularDepartments/index.js


/***/ }),

/***/ 76831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Product/product.js


var Product = function Product(_ref) {
  var title = _ref.title;
  return react.createElement("h1", null, title);
};
Product.initialData = {
  fragments: ['factsheet'],
  product: 'product-query'
};
 false ? 0 : void 0;
/* harmony default export */ var product = (Product);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Product/index.js


/***/ }),

/***/ 87757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductBundleSelector_ProductBundleSelector; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductBundleSelector/ProductBundleSelector.js


var _excluded = ["label", "labelAs"];








var BUNDLE_CLICK_EVENT = 'product:bundle:click';
var ProductBundleSelector = function ProductBundleSelector(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    layout = _ref.layout;
  var _useProductInfo = (0,hooks/* useProductInfo */.MW)(data == null ? void 0 : data.product),
    bundles = _useProductInfo.bundles,
    bundleId = _useProductInfo.bundleId;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var hasBundle = Array.isArray(bundles) && bundles.length > 1;
  var handleBundleClick = function handleBundleClick(id) {
    return function () {
      return publish(BUNDLE_CLICK_EVENT, id);
    };
  };
  var label = staticProps.label,
    labelAs = staticProps.labelAs,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  return hasBundle && react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "bundle-selection"
  }, layout, props), react.createElement(Box/* default */.Z, {
    as: labelAs,
    lineHeight: "big"
  }, label), react.createElement(Grid/* default */.Z, {
    gridAutoFlow: ['row', 'row', 'column', 'column'],
    mt: 3,
    gridGap: 3
  }, bundles.map(function (bundle) {
    return react.createElement(Button/* default */.Z, {
      "data-testid": "bundle-option",
      startIcon: react.createElement(ResponsiveImage/* default */.Z, {
        width: 80,
        height: 63,
        src: bundle.image,
        alt: "Imagem de ".concat(bundle.title),
        lazy: true,
        maxHeight: "60px",
        mr: 3
      }),
      onClick: handleBundleClick(bundle.id),
      disabled: bundle.id === bundleId,
      centered: true,
      variation: "outline",
      key: "bundle-".concat(bundle.id),
      minHeight: "80px"
    }, "".concat(bundle.title).concat(bundle.reference ? " - ".concat(bundle.reference) : ''));
  })));
};
ProductBundleSelector.defaultProps = {
  data: {},
  layout: {
    py: 3
  },
  "static": {
    label: 'Selecione um dos itens abaixo para visualizar suas especificações:',
    labelAs: 'p'
  }
};
 false ? 0 : void 0;
ProductBundleSelector.dataSource = {
  product: {
    fragments: ['includeFactSheet'],
    query: 'ProductQuery'
  }
};
/* harmony default export */ var ProductBundleSelector_ProductBundleSelector = (ProductBundleSelector);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductBundleSelector/index.js


/***/ }),

/***/ 61549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCard_ProductCard; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCard/ProductCard.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4;




var Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    bg: 'background.lighter',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100px;\n"])));
var Image = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z).attrs(function (props) {
  return {
    imageHeight: props.imageHeight && props.imageHeight.trim() !== '' ? props.imageHeight : '79px',
    imageWidth: props.imageWidth && props.imageWidth.trim() !== '' ? props.imageWidth : '79px',
    ml: '10px'
  };
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n"])));
var TextContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'flex-start',
    flexDirection: 'column',
    marginLeft: 2,
    textAlign: 'left'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 1,
    fontStyle: 'normal',
    lineHeight: 'display',
    marginTop: 2,
    maxWidth: '100%'
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCard/ProductCard.js


var _excluded = ["label", "imageWidth", "imageHeight", "fontSize", "showFullTitle"];






var ProductCard = function ProductCard(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var label = staticProps.label,
    imageWidth = staticProps.imageWidth,
    imageHeight = staticProps.imageHeight,
    fontSize = staticProps.fontSize,
    showFullTitle = staticProps.showFullTitle,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var _ref2 = (data == null ? void 0 : data.product) || {},
    image = _ref2.image,
    title = _ref2.title;
  var fullTitle = showFullTitle && title && (0,esm/* getFullTitle */.HV)(data == null ? void 0 : data.product);
  return react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "product-card-container"
  }, props), react.createElement(Image, {
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    src: image,
    alt: title,
    "data-testid": "product-card-img"
  }), react.createElement(TextContainer, {
    "data-testid": "product-card-section"
  }, label && react.createElement(Heading/* default */.Z, {
    as: "h2",
    color: "black",
    fontSize: 3,
    lineHeight: "display",
    fontWeight: "medium",
    "data-testid": "product-card-label"
  }, label), title && react.createElement(Title, {
    color: "black",
    fontSize: fontSize,
    "data-testid": "product-card-title"
  }, fullTitle || title)));
};
ProductCard.defaultProps = {
  data: {},
  "static": {
    label: ''
  }
};
 false ? 0 : void 0;
ProductCard.dataSource = {
  product: {
    fragments: ['includeDescription'],
    query: 'ProductQuery'
  }
};
ProductCard.ssr = true;
/* harmony default export */ var ProductCard_ProductCard = ((0,withLayoutProps/* default */.Z)(ProductCard));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCard/index.js


/***/ }),

/***/ 40780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCarouselSeller_ProductCarouselSeller; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var organisms_ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../modules/build/esm/commons/isServiceType.js
var isServiceType = __webpack_require__(19951);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductList/useProductList.js
var useProductList = __webpack_require__(92018);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCarouselSeller/ProductCarousel.js

var _excluded = ["enableHover", "imageHeight", "imageWidth", "showDiscount", "showDiscountOnlyCashInfo", "showInCashLabel", "attributeStyle", "colorMinLength", "isSellerPage", "isSlider", "displayMode", "auto", "showControls", "slidesPerView", "showPartialNextSlide", "showArrowControls", "showRating", "interval", "transitionDuration", "gutter", "productTitleAs", "imageAltPrefix", "imgLazyLoading", "cardType", "showBorder", "showOfferTimer", "showButton", "buttonProps", "hideOriginalPrice"];






var offerTimerProps = {
  bg: 'primary'
};
var ProductCarousel = function ProductCarousel(_ref) {
  var _structure$theme;
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$enableHo = _ref$static2.enableHover,
    enableHover = _ref$static2$enableHo === void 0 ? false : _ref$static2$enableHo,
    imageHeight = _ref$static2.imageHeight,
    imageWidth = _ref$static2.imageWidth,
    showDiscount = _ref$static2.showDiscount,
    showDiscountOnlyCashInfo = _ref$static2.showDiscountOnlyCashInfo,
    _ref$static2$showInCa = _ref$static2.showInCashLabel,
    showInCashLabel = _ref$static2$showInCa === void 0 ? true : _ref$static2$showInCa,
    attributeStyle = _ref$static2.attributeStyle,
    colorMinLength = _ref$static2.colorMinLength,
    _ref$static2$isSeller = _ref$static2.isSellerPage,
    isSellerPage = _ref$static2$isSeller === void 0 ? false : _ref$static2$isSeller,
    _ref$static2$isSlider = _ref$static2.isSlider,
    isSlider = _ref$static2$isSlider === void 0 ? false : _ref$static2$isSlider,
    _ref$static2$displayM = _ref$static2.displayMode,
    displayMode = _ref$static2$displayM === void 0 ? 'gallery' : _ref$static2$displayM,
    _ref$static2$auto = _ref$static2.auto,
    auto = _ref$static2$auto === void 0 ? false : _ref$static2$auto,
    _ref$static2$showCont = _ref$static2.showControls,
    showControls = _ref$static2$showCont === void 0 ? false : _ref$static2$showCont,
    _ref$static2$slidesPe = _ref$static2.slidesPerView,
    slidesPerView = _ref$static2$slidesPe === void 0 ? 5 : _ref$static2$slidesPe,
    _ref$static2$showPart = _ref$static2.showPartialNextSlide,
    showPartialNextSlide = _ref$static2$showPart === void 0 ? false : _ref$static2$showPart,
    _ref$static2$showArro = _ref$static2.showArrowControls,
    showArrowControls = _ref$static2$showArro === void 0 ? true : _ref$static2$showArro,
    _ref$static2$showRati = _ref$static2.showRating,
    showRating = _ref$static2$showRati === void 0 ? true : _ref$static2$showRati,
    _ref$static2$interval = _ref$static2.interval,
    interval = _ref$static2$interval === void 0 ? 5000 : _ref$static2$interval,
    _ref$static2$transiti = _ref$static2.transitionDuration,
    transitionDuration = _ref$static2$transiti === void 0 ? 400 : _ref$static2$transiti,
    _ref$static2$gutter = _ref$static2.gutter,
    gutter = _ref$static2$gutter === void 0 ? 2 : _ref$static2$gutter,
    _ref$static2$productT = _ref$static2.productTitleAs,
    productTitleAs = _ref$static2$productT === void 0 ? 'h2' : _ref$static2$productT,
    _ref$static2$imageAlt = _ref$static2.imageAltPrefix,
    imageAltPrefix = _ref$static2$imageAlt === void 0 ? '' : _ref$static2$imageAlt,
    _ref$static2$imgLazyL = _ref$static2.imgLazyLoading,
    imgLazyLoading = _ref$static2$imgLazyL === void 0 ? true : _ref$static2$imgLazyL,
    _ref$static2$cardType = _ref$static2.cardType,
    cardType = _ref$static2$cardType === void 0 ? 'vertical' : _ref$static2$cardType,
    _ref$static2$showBord = _ref$static2.showBorder,
    showBorder = _ref$static2$showBord === void 0 ? false : _ref$static2$showBord,
    _ref$static2$showOffe = _ref$static2.showOfferTimer,
    showOfferTimer = _ref$static2$showOffe === void 0 ? false : _ref$static2$showOffe,
    _ref$static2$showButt = _ref$static2.showButton,
    showButton = _ref$static2$showButt === void 0 ? false : _ref$static2$showButt,
    _ref$static2$buttonPr = _ref$static2.buttonProps,
    buttonProps = _ref$static2$buttonPr === void 0 ? {} : _ref$static2$buttonPr,
    _ref$static2$hideOrig = _ref$static2.hideOriginalPrice,
    hideOriginalPrice = _ref$static2$hideOrig === void 0 ? false : _ref$static2$hideOrig,
    staticProps = (0,objectWithoutProperties/* default */.Z)(_ref$static2, _excluded),
    structure = _ref.structure;
  var _useProductList = (0,useProductList/* default */.Z)({
      data: data,
      "static": staticProps,
      structure: structure
    }),
    display = _useProductList.display,
    handleProductMouseDown = _useProductList.handleProductMouseDown,
    handleProductClick = _useProductList.handleProductClick,
    handleProductView = _useProductList.handleProductView,
    handleThumbnailClick = _useProductList.handleThumbnailClick,
    isEmptyList = _useProductList.isEmptyList,
    products = _useProductList.products;
  if (isEmptyList || !(products == null ? void 0 : products.length)) {
    return null;
  }
  return react.createElement(organisms_ProductCarousel/* default */.Z, {
    products: products,
    displayMode: displayMode || display,
    onClick: handleProductClick,
    onMouseDown: handleProductMouseDown,
    onProductView: handleProductView,
    auto: auto,
    showControls: showControls,
    slidesPerView: slidesPerView,
    showPartialNextSlide: showPartialNextSlide,
    showArrowControls: showArrowControls,
    showRating: showRating,
    interval: interval,
    transitionDuration: transitionDuration,
    gutter: gutter,
    productTitleAs: productTitleAs,
    imageAltPrefix: imageAltPrefix,
    imgLazyLoading: imgLazyLoading,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    enableHover: enableHover,
    showInCashInfo: showInCashLabel,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    cardType: cardType,
    offerTimerProps: (structure == null ? void 0 : (_structure$theme = structure.theme) == null ? void 0 : _structure$theme.name) === 'magazineluiza-bf' ? offerTimerProps : undefined,
    showBorder: showBorder,
    showOfferTimer: showOfferTimer,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: hideOriginalPrice,
    hidePriceWhen: isServiceType/* default */.Z,
    hideShippingTagWhen: isServiceType/* default */.Z,
    isSellerPage: isSellerPage,
    isSlider: isSlider,
    onThumbnailClick: handleThumbnailClick,
    colorMinLength: colorMinLength,
    attributeStyle: attributeStyle
  });
};
 false ? 0 : void 0;
ProductCarousel.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
ProductCarousel.ssr = true;
ProductCarousel.displayName = 'ProductCarousel';
ProductCarousel.dataSource = {
  search: {
    query: 'SearchQuery'
  }
};
/* harmony default export */ var ProductCarouselSeller_ProductCarousel = ((0,withLayoutProps/* default */.Z)(ProductCarousel));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCarouselSeller/ProductCarouselSeller.js


var ProductCarouselSeller_excluded = ["brand", "categoryId", "pageSize", "sellerId", "subCategoryId", "sortOrientation", "sortType"];




var ProductCarouselSeller = function ProductCarouselSeller(_ref) {
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static$brand = _ref$static.brand,
    brand = _ref$static$brand === void 0 ? '' : _ref$static$brand,
    _ref$static$categoryI = _ref$static.categoryId,
    categoryId = _ref$static$categoryI === void 0 ? '' : _ref$static$categoryI,
    _ref$static$pageSize = _ref$static.pageSize,
    pageSize = _ref$static$pageSize === void 0 ? 10 : _ref$static$pageSize,
    sellerId = _ref$static.sellerId,
    _ref$static$subCatego = _ref$static.subCategoryId,
    subCategoryId = _ref$static$subCatego === void 0 ? '' : _ref$static$subCatego,
    _ref$static$sortOrien = _ref$static.sortOrientation,
    sortOrientation = _ref$static$sortOrien === void 0 ? '' : _ref$static$sortOrien,
    sortType = _ref$static.sortType,
    staticProps = (0,objectWithoutProperties/* default */.Z)(_ref$static, ProductCarouselSeller_excluded),
    structure = _ref.structure;
  var _useProductListBySell = (0,esm.useProductListBySeller)({
      brand: brand,
      categoryId: categoryId,
      pageSize: pageSize,
      sellerId: sellerId,
      sortOrientation: sortOrientation,
      sortType: sortType,
      subCategoryId: subCategoryId
    }),
    productList = _useProductListBySell.productList;
  return productList.length ? react.createElement(ProductCarouselSeller_ProductCarousel, {
    data: (0,esm_extends/* default */.Z)({}, data, {
      search: {
        products: productList
      }
    }),
    "static": (0,esm_extends/* default */.Z)({}, staticProps),
    structure: structure
  }) : null;
};
 false ? 0 : void 0;
ProductCarouselSeller.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
/* harmony default export */ var ProductCarouselSeller_ProductCarouselSeller = (ProductCarouselSeller);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCarouselSeller/index.js


/***/ }),

/***/ 60270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCoupon_ProductCoupon; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CouponCodeCopy/index.js + 2 modules
var CouponCodeCopy = __webpack_require__(57142);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCoupon/utils.js
var formattedDate = function formattedDate(date) {
  if (!date) return null;
  var parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime()) || parsedDate < new Date()) {
    return null;
  }
  return parsedDate.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short'
  });
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCoupon/ProductCoupon.styles.js

var _templateObject;

var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 8px 16px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCoupon/ProductCoupon.js








var ProductCoupon = function ProductCoupon(_ref) {
  var _product$seller, _product$seller$tags;
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var product = staticProps.product;
  var coupon = product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : (_product$seller$tags = _product$seller.tags) == null ? void 0 : _product$seller$tags.find(function (tag) {
    return (tag == null ? void 0 : tag.type) === 'coupon';
  });
  if (!coupon) return null;
  var code = coupon.code,
    discountType = coupon.discountType,
    discountValue = coupon.discountValue,
    endDate = coupon.endDate,
    message = coupon.message;
  var useInViewConfig = {
    threshold: 0.5,
    triggerOnce: true
  };
  var handleView = function handleView() {
    publish('coupon:viewItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: message
    });
  };
  var handleClick = function handleClick() {
    publish('coupon:selectItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: message
    });
  };
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(useInViewConfig),
    _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  (0,react.useEffect)(function () {
    if (inView && coupon) {
      handleView();
    }
  }, [inView]);
  return react.createElement(Container, {
    ref: ref
  }, react.createElement(CouponCodeCopy/* default */.Z, {
    code: code.toUpperCase(),
    discountType: discountType,
    discountValue: discountValue,
    expirationDate: formattedDate(endDate),
    auxiliaryText: "Copie o cupom e cole na revis\xE3o. V\xE1lido at\xE9",
    onCopySuccess: handleClick
  }));
};
 false ? 0 : void 0;
ProductCoupon.defaultProps = {
  "static": {},
  structure: {}
};
ProductCoupon.ssr = false;
ProductCoupon.displayName = 'ProductCoupon';
/* harmony default export */ var ProductCoupon_ProductCoupon = (ProductCoupon);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductCoupon/index.js


/***/ }),

/***/ 9747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductDetail_ProductDetail; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductBundleSelector/index.js + 1 modules
var ProductBundleSelector = __webpack_require__(87757);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/index.js + 1 modules
var VisibilitySection = __webpack_require__(17322);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/RichDescription/index.js + 2 modules
var RichDescription = __webpack_require__(15439);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductDetail/ProductDetail.styles.js


var _templateObject, _templateObject2;


var Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    px: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Description = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'text.base',
    fontWeight: 'regular',
    lineHeight: 'big',
    textAlign: 'justify'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductDetail/ProductDetail.js


var _excluded = ["label", "labelAs", "titleAs", "marginBottomScroll"];











var baseTitle = {
  color: 'base',
  fontSize: 2,
  fontWeight: 'bold',
  lineHeight: 'display',
  my: [2, 2, 3, 3]
};
function ProductDetail(_ref) {
  var data = _ref.data,
    onClick = _ref.onClick,
    staticProps = _ref["static"];
  var elemRef = (0,react.useRef)(null);
  var _useProductInfo = (0,hooks/* useProductInfo */.MW)(data == null ? void 0 : data.product, {
      getRawDescription: true
    }),
    _useProductInfo$title = _useProductInfo.title,
    title = _useProductInfo$title === void 0 ? '' : _useProductInfo$title,
    _useProductInfo$descr = _useProductInfo.description,
    description = _useProductInfo$descr === void 0 ? '' : _useProductInfo$descr;
  var label = staticProps.label,
    _staticProps$labelAs = staticProps.labelAs,
    labelAs = _staticProps$labelAs === void 0 ? 'h2' : _staticProps$labelAs,
    _staticProps$titleAs = staticProps.titleAs,
    titleAs = _staticProps$titleAs === void 0 ? 'span' : _staticProps$titleAs,
    marginBottomScroll = staticProps.marginBottomScroll,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var handleDetailClickEvent = function handleDetailClickEvent() {
    return (0,build_esm/* scrollToRef */.BC)(elemRef, marginBottomScroll);
  };
  (0,react.useEffect)(function () {
    subscribe('product:detail:click', onClick || handleDetailClickEvent);
    return function () {
      unsubscribe('product:detail:click', onClick || handleDetailClickEvent);
    };
  });
  return description && react.createElement(VisibilitySection/* default */.Z, {
    eventKey: "product:active:section",
    eventValue: "product:detail"
  }, react.createElement(Content, (0,esm_extends/* default */.Z)({
    "data-testid": "product-detail",
    ref: elemRef,
    yOffset: marginBottomScroll
  }, props), label && react.createElement(Heading/* default */.Z, (0,esm_extends/* default */.Z)({}, baseTitle, {
    fontSize: [2, 2, 5, 5],
    fontWeight: "medium",
    "data-testid": "product-detail-label",
    as: labelAs
  }), label), react.createElement(ProductBundleSelector/* default */.Z, {
    data: data
  }), react.createElement(Heading/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "product-detail-title"
  }, baseTitle, {
    as: titleAs
  }), title), react.createElement(Description, {
    fontSize: [1, 1, 2, 2],
    "data-testid": "product-detail-description"
  }, react.createElement(RichDescription/* default */.Z, {
    "static": {
      deniedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'div', 'img', 'svg'],
      richContent: description
    }
  }))));
}
ProductDetail.defaultProps = {
  data: {},
  onClick: null,
  "static": {
    label: 'Informações do produto',
    labelAs: 'h2',
    titleAs: 'h2'
  }
};
 false ? 0 : void 0;
ProductDetail.ssr = true;
ProductDetail.dataSource = {
  product: {
    fragments: ['includeDescription'],
    query: 'ProductQuery'
  }
};
/* harmony default export */ var ProductDetail_ProductDetail = ((0,withLayoutProps/* default */.Z)(ProductDetail));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductDetail/index.js


/***/ }),

/***/ 8758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductInfoBar_ProductInfoBar; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/BuyButtons/index.js + 7 modules
var BuyButtons = __webpack_require__(69510);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductInfoBar/ProductInfoBar.styles.js

var _templateObject;


var ProductInfoBar_styles_Text = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function () {
  return {
    fontSize: [4, 4, 5, 5],
    lineHeight: 'input',
    overflow: 'hidden'
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductInfoBar/ProductInfoBar.js







var ProductInfoBar = function ProductInfoBar(_ref) {
  var _product$price, _product$price2;
  var data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var _data$product = data.product,
    product = _data$product === void 0 ? {} : _data$product;
  var servicesPageLink = staticProps.servicesPageLink,
    _staticProps$showPric = staticProps.showPrice,
    showPrice = _staticProps$showPric === void 0 ? true : _staticProps$showPric,
    _staticProps$showBuyB = staticProps.showBuyButton,
    showBuyButton = _staticProps$showBuyB === void 0 ? true : _staticProps$showBuyB;
  var title = [product == null ? void 0 : product.title, product == null ? void 0 : product.reference].filter(Boolean).join(' - ') || '';
  return react.createElement(react.Fragment, null, react.createElement(ProductInfoBar_styles_Text, {
    "data-testid": "product-title"
  }, title), (product == null ? void 0 : product.available) && showPrice ? react.createElement(Box/* default */.Z, {
    color: "primary.base",
    fontSize: [4, 4, 5, 5],
    lineHeight: "fontSize"
  }, react.createElement(Box/* default */.Z, {
    fontWeight: ['regular', 'regular', 'bold', 'bold'],
    mr: 2,
    "data-testid": "product-price"
  }, (0,currencyFormatter/* default */.Z)({
    value: (product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.bestPrice) || (product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.price)
  }))) : null, showBuyButton && react.createElement(BuyButtons/* default */.Z, {
    data: data,
    "static": {
      bagButton: {
        icon: {
          height: 24,
          name: 'ShoppingBag',
          width: 24
        },
        label: 'Adicionar à Sacola',
        size: 'medium'
      },
      hideFloatButton: true,
      servicesPageLink: servicesPageLink
    },
    structure: structure,
    layout: {
      padding: 0,
      width: 'fit-content'
    }
  }));
};
 false ? 0 : void 0;
ProductInfoBar.defaultProps = {
  data: {},
  "static": {},
  structure: {
    config: {
      cartUrl: {
        guarantee: ''
      }
    }
  }
};
ProductInfoBar.ssr = false;
ProductInfoBar.displayName = 'ProductInfoBar';
/* harmony default export */ var ProductInfoBar_ProductInfoBar = ((0,withLayoutProps/* default */.Z)(ProductInfoBar));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductInfoBar/index.js


/***/ }),

/***/ 57899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _magalu_stereo_ui_organisms_ProductList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98284);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62624);
/* harmony import */ var _magalu_mixer_publisher__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87333);
/* harmony import */ var _commons_isServiceType__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19951);
/* harmony import */ var _hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89382);
/* harmony import */ var _useProductList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92018);


var _excluded = ["enableHover", "imageHeight", "imageWidth", "limit", "showDiscount", "showDiscountOnlyCashInfo", "showInCashLabel", "allowEmptyRating", "attributeStyle", "colorMinLength", "gridGap", "isSellerPage", "isSlider", "slidesPerView", "desktopMode", "itemWidth", "itemHeight"];








var offerTimerProps = {
  bg: 'primary'
};
var shouldShowWishButton = function shouldShowWishButton(isSellerPage, showWishBtn) {
  return !isSellerPage && showWishBtn;
};
var ProductList = function ProductList(_ref) {
  var _data$search, _data$search$fastFilt, _structure$theme;
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$enableHo = _ref$static2.enableHover,
    enableHover = _ref$static2$enableHo === void 0 ? false : _ref$static2$enableHo,
    imageHeight = _ref$static2.imageHeight,
    imageWidth = _ref$static2.imageWidth,
    _ref$static2$limit = _ref$static2.limit,
    limit = _ref$static2$limit === void 0 ? 0 : _ref$static2$limit,
    showDiscount = _ref$static2.showDiscount,
    showDiscountOnlyCashInfo = _ref$static2.showDiscountOnlyCashInfo,
    _ref$static2$showInCa = _ref$static2.showInCashLabel,
    showInCashLabel = _ref$static2$showInCa === void 0 ? true : _ref$static2$showInCa,
    _ref$static2$allowEmp = _ref$static2.allowEmptyRating,
    allowEmptyRating = _ref$static2$allowEmp === void 0 ? false : _ref$static2$allowEmp,
    attributeStyle = _ref$static2.attributeStyle,
    colorMinLength = _ref$static2.colorMinLength,
    _ref$static2$gridGap = _ref$static2.gridGap,
    gridGap = _ref$static2$gridGap === void 0 ? 2 : _ref$static2$gridGap,
    _ref$static2$isSeller = _ref$static2.isSellerPage,
    isSellerPage = _ref$static2$isSeller === void 0 ? false : _ref$static2$isSeller,
    _ref$static2$isSlider = _ref$static2.isSlider,
    isSlider = _ref$static2$isSlider === void 0 ? false : _ref$static2$isSlider,
    slidesPerView = _ref$static2.slidesPerView,
    desktopMode = _ref$static2.desktopMode,
    itemWidth = _ref$static2.itemWidth,
    itemHeight = _ref$static2.itemHeight,
    staticProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref$static2, _excluded),
    structure = _ref.structure;
  var _ref2 = (0,_useProductList__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
      data: data,
      "static": staticProps,
      structure: structure
    }) || {},
    display = _ref2.display,
    domain = _ref2.domain,
    handleAddToWishlist = _ref2.handleAddToWishlist,
    handleListShowMore = _ref2.handleListShowMore,
    handleProductMouseDown = _ref2.handleProductMouseDown,
    handleProductClick = _ref2.handleProductClick,
    handleProductView = _ref2.handleProductView,
    handleThumbnailClick = _ref2.handleThumbnailClick,
    handleVariationClick = _ref2.handleVariationClick,
    isEmptyList = _ref2.isEmptyList,
    products = _ref2.products,
    showWishilistButton = _ref2.showWishilistButton,
    handleAddToCart = _ref2.handleAddToCart,
    showAddToCartButton = _ref2.showAddToCartButton,
    ref = _ref2.ref;
  var showWishButton = shouldShowWishButton(isSellerPage, showWishilistButton);
  var _usePublisher = (0,_magalu_mixer_publisher__WEBPACK_IMPORTED_MODULE_4__/* .usePublisher */ .Np)(),
    publish = _usePublisher.publish;
  var parsedFilters = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$fastFilt = _data$search.fastFilters) == null ? void 0 : _data$search$fastFilt.length) > 1 && !desktopMode ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_3__/* .filtersParser */ .U8)({
    customCategoryFilter: false,
    data: data,
    filters: data.search.fastFilters,
    query: {},
    removeFilters: [],
    structure: structure
  }) : null;
  var onFilterClick = function onFilterClick(e, filter) {
    var _filter$values;
    e.preventDefault();
    var filters = ((_filter$values = filter.values) == null ? void 0 : _filter$values.length) ? filter.href.replace("".concat(filter.filterSlug, "---").concat(filter.slug), "".concat(filter.filterSlug, "---").concat(filter.values.join('--'))) : filter.href;
    publish('productlist:fastFilter:click', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, filter, {
      custom: false
    }));
    (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_3__/* .routePush */ .dY)({
      path: filters,
      spa: true
    });
  };
  var onFilterView = function onFilterView(_ref3) {
    var _filter$values2, _filter$values2$flatM;
    var filter = _ref3.filter;
    var eventLabel = filter == null ? void 0 : (_filter$values2 = filter.values) == null ? void 0 : (_filter$values2$flatM = _filter$values2.flatMap(function (item, idx) {
      return "".concat(idx + 1, "\xB0").concat(item.label, ":").concat(item.slug);
    })) == null ? void 0 : _filter$values2$flatM.join(';');
    publish('productlist:fastFilter:view', {
      custom: false,
      eventLabel: eventLabel
    });
  };
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_organisms_ProductList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    ref: ref,
    key: products,
    enableHover: enableHover,
    showInCashInfo: showInCashLabel,
    onClick: handleProductClick,
    onMouseDown: handleProductMouseDown,
    onClickLoadMore: handleListShowMore,
    data: products,
    displayMode: display,
    domain: domain,
    onProductView: handleProductView,
    partial: limit,
    notFound: isEmptyList,
    showWishBtn: showWishButton,
    onClickWishBtn: handleAddToWishlist,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    allowEmptyRating: allowEmptyRating,
    onThumbnailClick: handleThumbnailClick,
    onVariationClick: handleVariationClick,
    colorMinLength: colorMinLength,
    attributeStyle: attributeStyle,
    offerTimerProps: (structure == null ? void 0 : (_structure$theme = structure.theme) == null ? void 0 : _structure$theme.name) === 'magazineluiza-bf' ? offerTimerProps : undefined,
    gridGap: gridGap,
    isSellerPage: isSellerPage,
    isSlider: isSlider,
    addToCart: handleAddToCart,
    showAddToCartButton: showAddToCartButton,
    hidePriceWhen: _commons_isServiceType__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
    hideShippingTagWhen: _commons_isServiceType__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
    inlineFilters: parsedFilters,
    onFilterClick: onFilterClick,
    onFilterView: onFilterView,
    filterSlidesPerView: slidesPerView,
    filterItemHeight: itemHeight,
    desktopMode: desktopMode
  });
};
 false ? 0 : void 0;
ProductList.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
ProductList.ssr = true;
ProductList.displayName = 'ProductList';
ProductList.dataSource = {
  search: {
    query: 'SearchQuery'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ProductList));

/***/ }),

/***/ 28981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _ProductList__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ProductList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57899);


/***/ }),

/***/ 92018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86522);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56666);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34795);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59740);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95602);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(282);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _magalu_mixer_publisher__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87333);
/* harmony import */ var _magalu_mixer_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76613);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62624);
/* harmony import */ var _commons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46729);
/* harmony import */ var _MagaluAdsShowcase_hooks_useAdsSdk__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(42153);
/* harmony import */ var _hooks_useValidationCookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85978);
/* harmony import */ var _commons_getProductPrice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75690);
/* harmony import */ var _commons_product__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73659);







var _excluded = ["message"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }










var PRODUCTLIST_SELECT_ITEM_CLICK = 'productlist:selectItem:click';
function buildOrderedQuery(_ref) {
  var hasSponsoredAds = _ref.hasSponsoredAds,
    _ref$otherParams = _ref.otherParams,
    otherParams = _ref$otherParams === void 0 ? [] : _ref$otherParams,
    seller = _ref.seller;
  var queryParts = [];
  if (hasSponsoredAds) queryParts.push([_commons__WEBPACK_IMPORTED_MODULE_6__/* .ADS */ .GF, _commons__WEBPACK_IMPORTED_MODULE_6__/* .SPONSORED */ .B6]);
  queryParts.push.apply(queryParts, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(otherParams));
  if (seller) queryParts.push(['seller_id', seller]);
  return queryParts.map(function (_ref2) {
    var _ref3 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
  }).join('&');
}
function extractRemainingParams(rawUrl, customBasePath, domain) {
  try {
    var parsedUrl = new URL(rawUrl, customBasePath || domain);
    return Array.from(parsedUrl.searchParams.entries()).filter(function (_ref4) {
      var _ref5 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref4, 1),
        param = _ref5[0];
      return param !== _commons__WEBPACK_IMPORTED_MODULE_6__/* .ADS */ .GF && param !== 'seller_id';
    });
  } catch (_unused) {
    var normalizedPath = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .parsePath */ .cP)(rawUrl);
    var _normalizedPath$split = normalizedPath.split('?'),
      _normalizedPath$split2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_normalizedPath$split, 2),
      _normalizedPath$split3 = _normalizedPath$split2[1],
      searchParams = _normalizedPath$split3 === void 0 ? '' : _normalizedPath$split3;
    var params = new URLSearchParams(searchParams);
    return Array.from(params.entries()).filter(function (_ref6) {
      var _ref7 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref6, 1),
        param = _ref7[0];
      return param !== _commons__WEBPACK_IMPORTED_MODULE_6__/* .ADS */ .GF && param !== 'seller_id';
    });
  }
}
function extractPathname(path, customBasePath, domain) {
  try {
    var parsedUrl = new URL(path, customBasePath || domain);
    return parsedUrl.pathname;
  } catch (_unused2) {
    return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .parsePath */ .cP)(path).split('?')[0];
  }
}
function buildProductUrl(_ref8) {
  var _product$ads;
  var path = _ref8.path,
    product = _ref8.product,
    seller = _ref8.seller,
    customBasePath = _ref8.customBasePath,
    domain = _ref8.domain;
  var remainingParams = extractRemainingParams(path, customBasePath, domain);
  var queryString = buildOrderedQuery({
    hasSponsoredAds: !!(product == null ? void 0 : (_product$ads = product.ads) == null ? void 0 : _product$ads.sponsored),
    otherParams: remainingParams,
    seller: seller
  });
  var pathname = extractPathname(path, customBasePath, domain);
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .parsePath */ .cP)("".concat(pathname).concat(queryString ? "?".concat(queryString) : ''));
}
function extractColorVariations(thumbnails) {
  return thumbnails == null ? void 0 : thumbnails.reduce(function (acc, item) {
    return (item == null ? void 0 : item.type) === 'color' ? [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(acc), [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, item, {
      available: true
    })]) : acc;
  }, []);
}
function parseProductList(_ref9) {
  var page = _ref9.page,
    pageSize = _ref9.pageSize,
    inCashDescription = _ref9.inCashDescription,
    _ref9$isOnWishlist = _ref9.isOnWishlist,
    isOnWishlist = _ref9$isOnWishlist === void 0 ? function () {} : _ref9$isOnWishlist,
    products = _ref9.products,
    sellerId = _ref9.sellerId,
    customBasePath = _ref9.customBasePath,
    domain = _ref9.domain,
    _ref9$cartData = _ref9.cartData,
    cartData = _ref9$cartData === void 0 ? {} : _ref9$cartData;
  return products == null ? void 0 : products.map(function (product, index) {
    var _product$ads2, _product$seller, _product$seller2;
    var path = product.path,
      price = product.price,
      thumbnails = product.thumbnails;
    var favoredProduct = !!isOnWishlist(product.variationId);
    var colorVariations = extractColorVariations(thumbnails);
    var variationsValues = colorVariations == null ? void 0 : colorVariations.flatMap(function (item) {
      return item == null ? void 0 : item.value;
    });
    var parsedAttributes = [{
      label: 'Cor',
      type: 'color',
      values: variationsValues
    }];
    var isSponsoredWithAdsSeller = !!((product == null ? void 0 : (_product$ads2 = product.ads) == null ? void 0 : _product$ads2.sponsored) && (product == null ? void 0 : product.adsSellerId));
    var baseSeller = sellerId || (product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.id);
    var url = "".concat(customBasePath).concat(buildProductUrl({
      customBasePath: customBasePath,
      domain: domain,
      path: path,
      product: product,
      seller: isSponsoredWithAdsSeller ? undefined : baseSeller
    }));
    var urlRedirect = "".concat(customBasePath).concat(buildProductUrl({
      customBasePath: customBasePath,
      domain: domain,
      path: path,
      product: product,
      seller: isSponsoredWithAdsSeller ? product.adsSellerId : baseSeller
    }));
    var calculatedPosition = (page - 1) * pageSize + (index + 1);
    var normalizedId = (0,_commons_product__WEBPACK_IMPORTED_MODULE_8__/* .parseEcommerceProductId */ .Y)(product);
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, product, {
      description: (product == null ? void 0 : product.description) || (product == null ? void 0 : product.title),
      id: normalizedId,
      inBagQuantity: parseInt(cartData == null ? void 0 : cartData[product == null ? void 0 : product.variationId], 10),
      isOnWishlist: favoredProduct,
      minimumOrderQuantity: (product == null ? void 0 : product.minimumOrderQuantity) || 1,
      parsedAttributes: parsedAttributes,
      position: calculatedPosition,
      price: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, price, {
        paymentMethodDescription: inCashDescription || (price == null ? void 0 : price.paymentMethodDescription)
      }),
      tagCoupon: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .getCouponData */ .jF)(product == null ? void 0 : (_product$seller2 = product.seller) == null ? void 0 : _product$seller2.tags),
      thumbnails: colorVariations,
      title: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFullTitle */ .HV)(product),
      url: url,
      urlRedirect: urlRedirect
    });
  });
}
function parseNotFoundList(_ref10) {
  var _ref10$notFound = _ref10.notFound,
    _ref10$notFound$messa = _ref10$notFound.message,
    message = _ref10$notFound$messa === void 0 ? '' : _ref10$notFound$messa,
    remaining = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref10$notFound, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
    message: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .parseTextHighlight */ .aH)(message, 'query')
  }, remaining);
}
function useProductList(_ref11) {
  var _data$search;
  var _ref11$data = _ref11.data,
    data = _ref11$data === void 0 ? {} : _ref11$data,
    _ref11$static = _ref11["static"],
    staticProps = _ref11$static === void 0 ? {} : _ref11$static,
    _ref11$structure = _ref11.structure,
    structureProps = _ref11$structure === void 0 ? {} : _ref11$structure;
  if (!data) {
    return null;
  }
  var adsPath = staticProps.adsPath,
    _staticProps$display = staticProps.display,
    initialDisplay = _staticProps$display === void 0 ? 'gallery' : _staticProps$display,
    staticDomain = staticProps.domain,
    inCashDescription = staticProps.inCashDescription,
    _staticProps$label = staticProps.label,
    label = _staticProps$label === void 0 ? 'Ofertas do Dia' : _staticProps$label,
    _staticProps$position = staticProps.position,
    listPosition = _staticProps$position === void 0 ? 1 : _staticProps$position,
    _staticProps$notFound = staticProps.notFound,
    notFound = _staticProps$notFound === void 0 ? {} : _staticProps$notFound,
    _staticProps$origin = staticProps.origin,
    origin = _staticProps$origin === void 0 ? 'doory' : _staticProps$origin,
    _staticProps$pageSize = staticProps.pageSize,
    pageSize = _staticProps$pageSize === void 0 ? 20 : _staticProps$pageSize,
    _staticProps$showWish = staticProps.showWishBtn,
    showWishBtn = _staticProps$showWish === void 0 ? false : _staticProps$showWish,
    _staticProps$spa = staticProps.spa,
    spa = _staticProps$spa === void 0 ? false : _staticProps$spa,
    _staticProps$customBa = staticProps.customBasePath,
    customBasePath = _staticProps$customBa === void 0 ? '' : _staticProps$customBa,
    _staticProps$shouldIn = staticProps.shouldInitSdk,
    shouldInitSdk = _staticProps$shouldIn === void 0 ? false : _staticProps$shouldIn,
    _staticProps$context = staticProps.context,
    context = _staticProps$context === void 0 ? {} : _staticProps$context;
  var asPath = structureProps.asPath,
    _structureProps$confi = structureProps.config,
    _structureProps$confi2 = _structureProps$confi === void 0 ? {} : _structureProps$confi,
    cartUrl = _structureProps$confi2.cartUrl,
    structureDomain = _structureProps$confi2.domain,
    cookieDomain = _structureProps$confi2.cookieDomain,
    salesChannelId = _structureProps$confi2.salesChannelId,
    _structureProps$cooki = structureProps.cookies,
    _structureProps$cooki2 = _structureProps$cooki === void 0 ? {} : _structureProps$cooki,
    accountData = _structureProps$cooki2.accountData,
    customerId = _structureProps$cooki2.customerId,
    location = _structureProps$cooki2.location,
    device = structureProps.device,
    name = structureProps.name,
    _structureProps$route = structureProps.route,
    route = _structureProps$route === void 0 ? {} : _structureProps$route,
    resolvedUrl = structureProps.resolvedUrl;
  var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID,
    MLPARCEIRO = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .cookiesConstants.MLPARCEIRO */ .VD.MLPARCEIRO;
  var category = data == null ? void 0 : data.category;
  var search = (_data$search = data == null ? void 0 : data.search) !== null && _data$search !== void 0 ? _data$search : {};
  var initialProducts = search.products;
  var abTesting = search.abTesting,
    attributionToken = search.attributionToken,
    pagination = search.pagination;
  var isMobile = device === 'mobile';
  var cartId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .getCookie */ .ej)(ML2_SID);
  var enabledPrebasket = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .usePrebasketToggle */ ._L)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialDisplay),
    _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useState, 2),
    display = _useState2[0],
    setDisplay = _useState2[1];
  var _usePublisher = (0,_magalu_mixer_publisher__WEBPACK_IMPORTED_MODULE_3__/* .usePublisher */ .Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useCart = (0,_magalu_mixer_graphql__WEBPACK_IMPORTED_MODULE_4__.useCart)(),
    _useCart2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useCart, 1),
    _useCart2$ = _useCart2[0],
    addToCart = _useCart2$.addToCart,
    getCart = _useCart2$.getCart,
    removeItem = _useCart2$.removeItem;
  (0,_hooks_useValidationCookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(cartId, cookieDomain);
  var cartRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var bagCountRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
  var productIdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)('');
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .whereAmI.onClient */ .er.onClient) {
      var _JSON$parse;
      var storedCart = localStorage.getItem('cart');
      cartRef.current = storedCart ? JSON.parse(storedCart) : {};
      var storedBagCount = localStorage.getItem('bagCount');
      bagCountRef.current = storedBagCount ? ((_JSON$parse = JSON.parse(storedBagCount)) == null ? void 0 : _JSON$parse.value) || 0 : 0;
    }
  }, []);
  var syncCartToStorage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (cart) {
    cartRef.current = cart;
    localStorage.setItem('cart', JSON.stringify(cart));
  }, []);
  var syncBagCountToStorage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (itemsQuantity) {
    var count = parseInt(itemsQuantity, 10);
    bagCountRef.current = count;
    localStorage.setItem('bagCount', JSON.stringify({
      value: count
    }));
    window.dispatchEvent(new CustomEvent('local-storage-change', {
      detail: {
        itemId: 'value',
        storageKey: 'bagCount',
        value: count
      }
    }));
  }, []);
  var _useAdsFillrateEvents = (0,_magalu_mixer_graphql__WEBPACK_IMPORTED_MODULE_4__.useAdsFillrateEvents)(),
    sendAdsFillrate = _useAdsFillrateEvents.sendAdsFillrate;
  var _useAdsEvents = (0,_magalu_mixer_graphql__WEBPACK_IMPORTED_MODULE_4__.useAdsEvents)({
      adsPath: adsPath,
      customerId: customerId,
      data: {
        category: category
      },
      structure: {
        device: device,
        name: name,
        route: route
      }
    }),
    sendAdsImpressionEvents = _useAdsEvents.sendAdsImpressionEvents,
    sendAdsClickEvents = _useAdsEvents.sendAdsClickEvents;
  var _useWishlistProvider = (0,_magalu_mixer_graphql__WEBPACK_IMPORTED_MODULE_4__.useWishlistProvider)(),
    addToWishlist = _useWishlistProvider.addToWishlist,
    removeFromWishlist = _useWishlistProvider.removeFromWishlist,
    updateWishlist = _useWishlistProvider.updateWishlist,
    isOnWishlist = _useWishlistProvider.isOnWishlist;
  var filters = route.filters,
    _route$page = route.page,
    page = _route$page === void 0 ? 1 : _route$page,
    sellerId = route.sellerId,
    term = route.term,
    bypass = route.bypass,
    selectionId = route.selectionId;
  var domain = staticDomain || structureDomain;
  var showWishilistButton = showWishBtn;
  var ML_EXP = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .cookiesConstants.ML_EXP */ .VD.ML_EXP;
  var actualPageSize = (pagination == null ? void 0 : pagination.size) || pageSize;
  var routerCategory = structureProps.route || {};
  var list = (routerCategory == null ? void 0 : routerCategory.slug1) || (routerCategory == null ? void 0 : routerCategory.categorySlug) || name || 'null';
  var listValue = name === 'selecao' && selectionId ? selectionId : list;
  var eventData = {
    abTesting: abTesting,
    attributionToken: attributionToken,
    category: category,
    customer_id: accountData == null ? void 0 : accountData.customer_id,
    display: display,
    filters: filters,
    list: listValue,
    listPosition: listPosition,
    offset: ((pagination == null ? void 0 : pagination.page) - 1) * actualPageSize,
    origin: origin,
    pageName: name,
    term: route.term
  };
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
    _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useState3, 2),
    currentNode = _useState4[0],
    setCurrentNode = _useState4[1];
  var productsNotFound = parseNotFoundList({
    notFound: notFound
  });
  var getInitialCartData = function getInitialCartData() {
    if (_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .whereAmI.onClient */ .er.onClient) {
      var storedCart = localStorage.getItem('cart');
      return storedCart ? JSON.parse(storedCart) : {};
    }
    return {};
  };
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function () {
      return parseProductList({
        cartData: getInitialCartData(),
        customBasePath: customBasePath,
        domain: domain,
        inCashDescription: inCashDescription,
        page: page,
        pageSize: actualPageSize,
        products: initialProducts,
        sellerId: sellerId
      });
    }),
    _useState6 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useState5, 2),
    products = _useState6[0],
    setProducts = _useState6[1];
  var adsProducts = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .sponsoredProducts */ .nn)(products);
  var updateProducts = function updateProducts() {
    return setProducts(parseProductList({
      cartData: cartRef.current || {},
      customBasePath: customBasePath,
      domain: domain,
      inCashDescription: inCashDescription,
      isOnWishlist: isOnWishlist,
      page: page,
      pageSize: actualPageSize,
      products: initialProducts,
      sellerId: sellerId
    }));
  };
  function normalizeAdsFillRateEvent() {
    var _ref12, _route$categorySlug, _window, _window$location, _category$, _category$2;
    var fillrates = [];
    var _search$adsFillRate = search.adsFillRate,
      eventId = _search$adsFillRate.eventId,
      placement = _search$adsFillRate.placement,
      requested = _search$adsFillRate.requested,
      received = _search$adsFillRate.received;
    var searchTerm = (_ref12 = (_route$categorySlug = route.categorySlug) !== null && _route$categorySlug !== void 0 ? _route$categorySlug : term) !== null && _ref12 !== void 0 ? _ref12 : '';
    fillrates.push({
      adType: 'SPONSORED_PRODUCT',
      channel: context.channel,
      eventId: eventId,
      page: (context == null ? void 0 : context.page) || "UNKNOWN_WEB_".concat((_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.href),
      placement: placement,
      received: {
        categories: [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Set(adsProducts.map(function (product) {
          var _product$category;
          return (_product$category = product.category) == null ? void 0 : _product$category.id;
        }))), (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Set(adsProducts.map(function (product) {
          var _product$subcategory;
          return (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.id;
        })))),
        clientAdsAmount: adsProducts.length,
        serverAdsAmount: received.serverAdsAmount,
        skus: (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Set(adsProducts.map(function (_ref13) {
          var id = _ref13.id;
          return id;
        })))
      },
      requested: {
        categories: (category == null ? void 0 : (_category$ = category[0]) == null ? void 0 : _category$.id) ? [category == null ? void 0 : (_category$2 = category[0]) == null ? void 0 : _category$2.id] : [''],
        clientAdsAmount: requested.clientAdsAmount,
        serverAdsAmount: requested.serverAdsAmount
      },
      searchTerm: searchTerm
    });
    return fillrates;
  }
  function handleExperimentCookie() {
    if (bypass) return;
    var currentExperiment = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .getCookie */ .ej)(ML_EXP);
    var hasDiffInExperiment = (abTesting == null ? void 0 : abTesting.experimentName) !== currentExperiment;
    if (abTesting == null ? void 0 : abTesting.id) {
      if (!currentExperiment || hasDiffInExperiment) {
        (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .setCookie */ .d8)({
          domain: cookieDomain,
          name: ML_EXP,
          value: abTesting == null ? void 0 : abTesting.experimentName
        });
        publish('productlist:start:experiment', {
          abTesting: abTesting
        });
      }
    } else {
      (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .removeCookie */ .nJ)(ML_EXP, cookieDomain, '/');
    }
  }
  function handleProductMouseDown(e, product) {
    var _product$ads3;
    if (product == null ? void 0 : (_product$ads3 = product.ads) == null ? void 0 : _product$ads3.sponsored) {
      sendAdsClickEvents([(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, product.ads, {
        adType: 'SPONSORED_PRODUCT'
      })]);
    } else if (route == null ? void 0 : route.track_id) {
      sendAdsClickEvents([{
        additionalAttribution: {
          id: product.id,
          type: 'product'
        },
        adType: 'SPONSORED_PRODUCT',
        trackId: route.track_id
      }]);
    }
  }
  var showAddToCartButton = function showAddToCartButton(product) {
    var _product$subcategory2;
    var denyListsubCategoryIds = ['CRED', 'SEGR', 'SPEP', 'SMOV', 'STAV', 'SARV', 'SEIF', 'SELA', 'SVAU', 'PEET', 'SPSD', 'SGRS', 'REFR', 'FORN', 'MOND', 'LALO', 'ELA1', 'LAVA', 'MMLP', 'SELT', 'FREE', 'CEDO', 'ADEG', 'ARAR'];
    var isDenyListed = denyListsubCategoryIds.indexOf(product == null ? void 0 : (_product$subcategory2 = product.subcategory) == null ? void 0 : _product$subcategory2.id) !== -1;
    return !isDenyListed;
  };
  var debouncedHandleCart = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default()(function () {
      var _ref14 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee(product, productId, quantity, rollback, variables) {
        var currentCart, previousQuantity, isAddingNewItemToCart, _product$seller3, _yield$removeItem, _error, cartValues, itemsQuantity, _yield$addToCart, addToCartData, error, rollbackCart, _cartData$totals, _yield$getCart, cartData, _addToCartData$totals;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              currentCart = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, cartRef.current || {});
              previousQuantity = currentCart[productId];
              isAddingNewItemToCart = previousQuantity === undefined;
              if (!(quantity === '0' && previousQuantity === undefined)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              if (!(quantity === '0')) {
                _context.next = 22;
                break;
              }
              if (Object.prototype.hasOwnProperty.call(currentCart, productId)) {
                delete currentCart[productId];
              }
              cartRef.current = currentCart;
              _context.next = 10;
              return removeItem({
                id: variables == null ? void 0 : variables.id,
                productId: productId,
                seller: product == null ? void 0 : (_product$seller3 = product.seller) == null ? void 0 : _product$seller3.id,
                stwu: customerId
              }, {
                loading: false
              });
            case 10:
              _yield$removeItem = _context.sent;
              _error = _yield$removeItem.error;
              if (!_error) {
                _context.next = 16;
                break;
              }
              if (previousQuantity !== undefined) {
                cartRef.current = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, cartRef.current, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, productId, previousQuantity));
              }
              rollback();
              return _context.abrupt("return");
            case 16:
              syncCartToStorage(currentCart);
              cartValues = Object.values(currentCart);
              itemsQuantity = cartValues.length > 0 ? cartValues.reduce(function (acc, it) {
                return parseInt(acc, 10) + parseInt(it, 10);
              }, 0) : 0;
              syncBagCountToStorage(itemsQuantity);
              publish('product:removeFromCart', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, {
                cartId: variables == null ? void 0 : variables.id,
                product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, product),
                quantity: variables == null ? void 0 : variables.quantity,
                typeButton: _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .ADD_TO_BAG */ .wO
              }));
              return _context.abrupt("return");
            case 22:
              currentCart[productId] = String(quantity);
              cartRef.current = currentCart;
              if (isAddingNewItemToCart) {
                handleProductMouseDown(null, product);
              }
              _context.next = 27;
              return addToCart(variables, {
                loading: false,
                updatePreBasket: enabledPrebasket && !isAddingNewItemToCart
              });
            case 27:
              _yield$addToCart = _context.sent;
              addToCartData = _yield$addToCart.data;
              error = _yield$addToCart.error;
              if (!error) {
                _context.next = 34;
                break;
              }
              if (previousQuantity !== undefined) {
                cartRef.current = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, cartRef.current, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, productId, previousQuantity));
              } else {
                rollbackCart = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, cartRef.current);
                delete rollbackCart[productId];
                cartRef.current = rollbackCart;
              }
              rollback();
              return _context.abrupt("return");
            case 34:
              syncCartToStorage(currentCart);
              if (!enabledPrebasket) {
                _context.next = 43;
                break;
              }
              _context.next = 38;
              return getCart(null, customerId);
            case 38:
              _yield$getCart = _context.sent;
              cartData = _yield$getCart.data.cart;
              syncBagCountToStorage(cartData == null ? void 0 : (_cartData$totals = cartData.totals) == null ? void 0 : _cartData$totals.itemsQuantity);
              _context.next = 44;
              break;
            case 43:
              syncBagCountToStorage(addToCartData == null ? void 0 : (_addToCartData$totals = addToCartData.totals) == null ? void 0 : _addToCartData$totals.itemsQuantity);
            case 44:
              publish('addtocart:success', {
                cartId: (addToCartData == null ? void 0 : addToCartData.cartId) || cartId,
                channel: salesChannelId || '',
                location: location,
                product: product,
                typeButton: _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .ONE_TOUCH */ .$1
              });
              publish(PRODUCTLIST_SELECT_ITEM_CLICK, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, product));
              publish('productlist:click', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, product));
              publish('product:addToCart', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, {
                cartId: (addToCartData == null ? void 0 : addToCartData.cartId) || cartId,
                product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, product),
                quantity: variables == null ? void 0 : variables.quantity,
                typeButton: _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .ADD_TO_BAG */ .wO
              }));
            case 48:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3, _x4, _x5) {
        return _ref14.apply(this, arguments);
      };
    }(), 600);
  }, []);
  var handleAddToCart = function handleAddToCart(product, productId, quantity, rollback) {
    try {
      var _product$seller4;
      var variables = {
        channelId: salesChannelId,
        extensions: false,
        id: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .getCookie */ .ej)(ML2_SID),
        item: {
          id: productId,
          price: (0,_commons_getProductPrice__WEBPACK_IMPORTED_MODULE_15__/* .getProductPrice */ .m)(product),
          title: product == null ? void 0 : product.title
        },
        partnerId: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .getCookie */ .ej)(MLPARCEIRO),
        productId: productId,
        quantity: quantity,
        sellerId: product == null ? void 0 : (_product$seller4 = product.seller) == null ? void 0 : _product$seller4.id,
        services: [],
        stwu: customerId
      };
      if (productId !== productIdRef.current) {
        productIdRef.current = productId;
        debouncedHandleCart.flush();
      }
      debouncedHandleCart(product, productId, quantity, rollback, variables);
      return {
        status: 'OK'
      };
    } catch (error) {
      return null;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isMobile && search.viewMode !== null) {
      setDisplay(search.viewMode);
    }
    if (showWishilistButton) {
      (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", updateWishlist());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
    (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            updateProducts();
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
    handleExperimentCookie();
    subscribe('productlist:display:change', function (_ref17) {
      var id = _ref17.id;
      return setDisplay(id);
    });
    publish('productlist:impression', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, {
      products: products
    }));
    if (search.adsFillRate) {
      var fillrates = normalizeAdsFillRateEvent();
      sendAdsFillrate(fillrates);
    }
    return function () {
      unsubscribe('productlist:display:change', function (_ref18) {
        var id = _ref18.id;
        return setDisplay(id);
      });
    };
  }, [asPath, JSON.stringify(route)]);
  var isEmptyList = !(products == null ? void 0 : products.length) && productsNotFound;
  function handleProductView(product) {
    var _product$ads4;
    publish('product:view', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, {
      product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, product, {
        position: (product == null ? void 0 : product.index) + 1
      })
    }));
    publish('product:viewItemList', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, product));
    if (product == null ? void 0 : (_product$ads4 = product.ads) == null ? void 0 : _product$ads4.sponsored) {
      sendAdsImpressionEvents([(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, product.ads, {
        adType: 'SPONSORED_PRODUCT'
      })]);
    }
  }
  function handleProductClick(e, product) {
    e.stopPropagation();
    e.preventDefault();
    publish(PRODUCTLIST_SELECT_ITEM_CLICK, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, product));
    publish('productlist:click', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, product));
    (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .routePush */ .dY)({
      path: product == null ? void 0 : product.urlRedirect,
      spa: spa
    });
  }
  function handleThumbnailClick(e, product, variation) {
    e.stopPropagation();
    e.preventDefault();
    var productWithNormalizedId = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, product, variation, {
      id: (0,_commons_product__WEBPACK_IMPORTED_MODULE_8__/* .parseEcommerceProductId */ .Y)(variation || product)
    });
    publish(PRODUCTLIST_SELECT_ITEM_CLICK, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, productWithNormalizedId));
    publish('variation:click', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, productWithNormalizedId));
    (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .routePush */ .dY)({
      path: "/".concat(product == null ? void 0 : product.path),
      spa: spa
    });
  }
  function handleListShowMore() {
    publish('productlist:showmore', {
      eventLabel: label
    });
  }
  function handleAddToWishlist(_x6, _x7) {
    return _handleAddToWishlist.apply(this, arguments);
  }
  function _handleAddToWishlist() {
    _handleAddToWishlist = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee4(e, product) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            e.stopPropagation();
            e.preventDefault();
            if (!(accountData == null ? void 0 : accountData.id)) {
              _context4.next = 9;
              break;
            }
            if (!isOnWishlist(product == null ? void 0 : product.variationId)) {
              publish('addToWishlist:click', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, product));
            }
            if (isOnWishlist(product == null ? void 0 : product.variationId)) {
              publish('removeFromWishList:click', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData, product));
            }
            _context4.next = 7;
            return (0,_commons__WEBPACK_IMPORTED_MODULE_6__/* .buildWishListActions */ .rz)({
              addToWishlist: addToWishlist,
              publish: publish,
              removeFromWishlist: removeFromWishlist,
              shouldUpdateHeart: updateProducts
            })({
              customerId: accountData == null ? void 0 : accountData.id,
              isLiked: product == null ? void 0 : product.isOnWishlist,
              product: product
            });
          case 7:
            _context4.next = 10;
            break;
          case 9:
            (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_5__/* .cartRedirect */ ._V)({
              cartUrl: cartUrl,
              next: "".concat(domain).concat(asPath),
              type: 'login'
            });
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _handleAddToWishlist.apply(this, arguments);
  }
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (node) {
    if (node !== null) {
      setCurrentNode(node);
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var parsedProducts = parseProductList({
      cartData: cartRef.current || {},
      customBasePath: customBasePath,
      domain: domain,
      inCashDescription: inCashDescription,
      isOnWishlist: isOnWishlist,
      page: page,
      pageSize: actualPageSize,
      products: initialProducts,
      sellerId: sellerId
    });
    if ((parsedProducts == null ? void 0 : parsedProducts.length) && shouldInitSdk && currentNode) {
      var uriOrTerm = term ? {
        searchTerm: term
      } : {
        pageUri: resolvedUrl
      };
      var flattenedAndParsedAds = adsProducts == null ? void 0 : adsProducts.flatMap(function (item) {
        return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, item.ads, {
          adId: item.ads.id,
          name: item.title,
          publisherId: context.publisherId,
          sellerId: item.seller.id,
          type: 'SPONSORED_PRODUCT'
        });
      });
      (0,_MagaluAdsShowcase_hooks_useAdsSdk__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, context, uriOrTerm, {
        target: currentNode
      }), flattenedAndParsedAds);
    }
  }, [currentNode]);
  return {
    display: display,
    domain: domain,
    handleAddToCart: handleAddToCart,
    handleAddToWishlist: handleAddToWishlist,
    handleListShowMore: handleListShowMore,
    handleProductClick: handleProductClick,
    handleProductMouseDown: handleProductMouseDown,
    handleProductView: handleProductView,
    handleThumbnailClick: handleThumbnailClick,
    isEmptyList: isEmptyList,
    products: products,
    ref: ref,
    showAddToCartButton: showAddToCartButton,
    showWishilistButton: showWishilistButton
  };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProductList);

/***/ }),

/***/ 86505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductListSeller_ProductListSeller; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductList/ProductList.js
var ProductList = __webpack_require__(57899);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductListSeller/ProductListSeller.js


var _excluded = ["brand", "categoryId", "pageSize", "sellerId", "subCategoryId", "sortOrientation", "sortType"];




var ProductListSeller = function ProductListSeller(_ref) {
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static$brand = _ref$static.brand,
    brand = _ref$static$brand === void 0 ? '' : _ref$static$brand,
    _ref$static$categoryI = _ref$static.categoryId,
    categoryId = _ref$static$categoryI === void 0 ? '' : _ref$static$categoryI,
    _ref$static$pageSize = _ref$static.pageSize,
    pageSize = _ref$static$pageSize === void 0 ? 10 : _ref$static$pageSize,
    sellerId = _ref$static.sellerId,
    _ref$static$subCatego = _ref$static.subCategoryId,
    subCategoryId = _ref$static$subCatego === void 0 ? '' : _ref$static$subCatego,
    _ref$static$sortOrien = _ref$static.sortOrientation,
    sortOrientation = _ref$static$sortOrien === void 0 ? '' : _ref$static$sortOrien,
    sortType = _ref$static.sortType,
    staticProps = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded),
    structure = _ref.structure;
  var _useProductListBySell = (0,esm.useProductListBySeller)({
      brand: brand,
      categoryId: categoryId,
      pageSize: pageSize,
      sellerId: sellerId,
      sortOrientation: sortOrientation,
      sortType: sortType,
      subCategoryId: subCategoryId
    }),
    productList = _useProductListBySell.productList;
  return productList.length ? react.createElement(ProductList/* default */.Z, {
    data: (0,esm_extends/* default */.Z)({}, data, {
      search: {
        products: productList
      }
    }),
    "static": (0,esm_extends/* default */.Z)({}, staticProps),
    structure: structure
  }) : null;
};
 false ? 0 : void 0;
ProductListSeller.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
/* harmony default export */ var ProductListSeller_ProductListSeller = (ProductListSeller);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductListSeller/index.js


/***/ }),

/***/ 80992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductPrice_ProductPrice; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Badge/index.js + 2 modules
var Badge = __webpack_require__(98460);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Price/index.js + 9 modules
var Price = __webpack_require__(23458);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductPrice/ProductPrice.js






var ProductPrice = function ProductPrice(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var cashLabelFallback = staticProps.cashLabelFallback,
    _staticProps$minimumI = staticProps.minimumInstallment,
    minimumInstallment = _staticProps$minimumI === void 0 ? 1 : _staticProps$minimumI,
    showTotalAmount = staticProps.showTotalAmount;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    badges = _ref2.badges,
    productPrice = _ref2.price,
    installment = _ref2.installment;
  var _ref3 = productPrice || {},
    bestPrice = _ref3.bestPrice,
    fullPrice = _ref3.fullPrice,
    discount = _ref3.discount,
    paymentMethodDescription = _ref3.paymentMethodDescription,
    price = _ref3.price;
  var badge = badges == null ? void 0 : badges.slice(-1)[0];
  (0,hooks/* useLastViewingProducts */.YP)((data == null ? void 0 : data.product) || {});
  return react.createElement(react.Fragment, null, !!price && react.createElement("div", {
    "data-testid": "product-price"
  }, react.createElement(Price/* default */.Z, {
    price: price,
    fullPrice: fullPrice,
    bestPrice: bestPrice,
    installment: installment,
    paymentMethodDescription: paymentMethodDescription || cashLabelFallback,
    discount: Math.round(discount),
    minimumInstallment: minimumInstallment,
    showDiscount: true,
    isList: false,
    showTotalAmount: showTotalAmount
  })), !!badge && react.createElement(Badge/* default */.Z, {
    key: badge.tooltip,
    url: badge.imageUrl,
    tooltip: "selo sobre a promo\xE7\xE3o ".concat(badge.tooltip),
    displayMode: "productPage"
  }));
};
 false ? 0 : void 0;
ProductPrice.defaultProps = {
  data: {},
  "static": {}
};
ProductPrice.ssr = true;
ProductPrice.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
/* harmony default export */ var ProductPrice_ProductPrice = ((0,withLayoutProps/* default */.Z)(ProductPrice));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductPrice/index.js


/***/ }),

/***/ 73070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductQAHighlights_ProductQAHighlights; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/index.js + 1 modules
var VisibilitySection = __webpack_require__(17322);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductQAHighlights/ProductQAHighlights.js





function ProductQAHighlights(_ref) {
  var _data$productHighligh;
  var staticProps = _ref["static"],
    data = _ref.data,
    id = _ref.id;
  var _ref2 = (_data$productHighligh = data == null ? void 0 : data.productHighlights) !== null && _data$productHighligh !== void 0 ? _data$productHighligh : {},
    highlights = _ref2.highlights;
  var title = staticProps.title,
    aiDescription = staticProps.aiDescription;
  if (highlights === null || !(highlights == null ? void 0 : highlights.length)) {
    return null;
  }
  return react.createElement(VisibilitySection/* default */.Z, {
    eventKey: "view_content",
    eventValue: "produto:perguntas"
  }, react.createElement(atoms/* Box */.xu, {
    "data-testid": id,
    id: id,
    maxWidth: "600px",
    mt: 30,
    mb: 50
  }, react.createElement(atoms/* Heading */.X6, {
    as: "h2",
    color: "base",
    fontSize: 5,
    fontWeight: "medium"
  }, title), react.createElement(atoms/* Box */.xu, null, highlights.map(function (_ref3) {
    var summary = _ref3.summary,
      topic = _ref3.topic;
    return react.createElement(atoms/* Box */.xu, {
      key: topic
    }, react.createElement(atoms/* Heading */.X6, {
      as: "h4",
      color: "base",
      fontSize: 2,
      fontWeight: "medium",
      mt: 4,
      mb: 2
    }, topic), react.createElement(atoms/* Text */.xv, {
      lineHeight: 1.25,
      ml: 3,
      mt: 3
    }, summary));
  })), react.createElement(atoms/* Box */.xu, {
    mt: 4,
    display: "flex"
  }, react.createElement(atoms/* Box */.xu, null, react.createElement(esm/* StarGroup */.rlX, {
    fill: "#999"
  })), react.createElement(atoms/* Box */.xu, {
    ml: 2,
    mt: 1
  }, react.createElement(atoms/* Text */.xv, {
    color: "#999",
    fontSize: 1,
    lineHeight: 1.25
  }, aiDescription)))));
}
 false ? 0 : void 0;
ProductQAHighlights.defaultProps = {
  data: {
    productHighlights: {
      highlights: []
    }
  },
  id: '',
  "static": {
    aiDescription: '',
    title: ''
  }
};
ProductQAHighlights.ssr = true;
/* harmony default export */ var ProductQAHighlights_ProductQAHighlights = (ProductQAHighlights);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductQAHighlights/index.js


/***/ }),

/***/ 52427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ProductReviewForm_ProductReviewForm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useUserData.js
var useUserData = __webpack_require__(16666);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ReviewModal/index.js + 2 modules
var ReviewModal = __webpack_require__(34561);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(71941);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/services/sendMediaReview.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }

var generateSignature = function generateSignature(secret, payload) {
  return crypto_browserify_default().createHmac('sha256', secret).update(payload).digest('hex');
};
var uploadMediaReview = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(headersParams, file, structure, customerId) {
    var _structure$config, _structure$config$rev;
    var clientIdEufrazino, secret, payload, signature, baseUrl, headers, mediaType, bodyData, response, _yield$response$json, media, errors;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          clientIdEufrazino = (structure == null ? void 0 : structure.site) === 'mini-apps' ? 'appmagalu' : 'mixer-review';
          secret = customerId;
          payload = clientIdEufrazino;
          signature = generateSignature(secret, payload);
          baseUrl = structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : (_structure$config$rev = _structure$config.review) == null ? void 0 : _structure$config$rev.mediaApi;
          headers = (0,esm_extends/* default */.Z)({
            'X-Client-Id': clientIdEufrazino,
            'X-Custom-Signature': signature,
            'X-Customer-Id': secret
          }, headersParams);
          mediaType = file.type.split('/')[0];
          bodyData = new FormData();
          bodyData.append('file', file);
          _context.next = 11;
          return fetch("".concat(baseUrl, "/api/review/v1/").concat(mediaType, "/upload"), {
            body: bodyData,
            headers: headers,
            method: 'POST'
          });
        case 11:
          response = _context.sent;
          if (response.ok) {
            _context.next = 14;
            break;
          }
          throw new Error("Response status: ".concat(response.status));
        case 14:
          _context.next = 16;
          return response.json();
        case 16:
          _yield$response$json = _context.sent;
          media = _yield$response$json.media;
          errors = _yield$response$json.errors;
          if (!(errors && errors.length)) {
            _context.next = 21;
            break;
          }
          throw new Error("Upload failed with status: ".concat(errors[0].message, ", with secret: ").concat(secret));
        case 21:
          return _context.abrupt("return", {
            mediaId: media == null ? void 0 : media.id,
            mediaType: mediaType
          });
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function uploadMediaReview(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/constants.js
var ALLOWED_FILE_TYPES = ['image', 'video'];
var ALLOWED_IMG_EXT = ['bmp', 'jpeg', 'jpg', 'heic', 'heif', 'png'];
var ALLOWED_VIDEO_EXT = ['mov', 'mp4', 'quicktime'];
var MAX_COMMENT_LENGTH = 1000;
var MAX_IMG_HEIGHT = 1080;
var MAX_IMG_QTD = 2;
var MAX_IMG_SIZE = 10000000;
var MAX_IMG_WIDTH = 1920;
var MAX_VIDEO_QTD = 1;
var MAX_VIDEO_SIZE = 100000000;
var msgErrorGeneral = 'Arquivo inválido. Não há suporte para o tipo ou formato.';
var msgErrorImgQtd = 'Só é permitido enviar no máximo 2 imagens.';
var msgErrorImgSize = 'Não é possível enviar imagens com mais de 10MB.';
var msgErrorVideoQtd = 'Só é permitido enviar no máximo 1 vídeo.';
var msgErrorVideoSize = 'Não é possível enviar vídeo com mais de 100MB.';
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/components/AttachReviewMedia/AttachReviewMedia.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;





var AttachDialog = (0,styled_components_browser_esm["default"])(Dialog/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 90%;\n  height: 90%;\n  max-width: 720px;\n  max-height: 640px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var AttachedImage = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 18px;\n  object-fit: cover;\n  height: 150px;\n  width: 150px;\n"])));
var AttachedVideo = styled_components_browser_esm["default"].video(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 18px;\n  height: 150px;\n  object-fit: cover;\n  width: 150px;\n"])));
var AttachmentGaleryContainer = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow-x: scroll;\n  margin-top: 20px;\n"])));
var AttachmentGaleryItem = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n  flex-direction: reverse-row;\n"])));
var AttachmentGaleryList = styled_components_browser_esm["default"].div(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 10px;\n"])));
var DeleteAttachment = styled_components_browser_esm["default"].button(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  position: absolute;\n  right: 3%;\n  top: 5%;\n  cursor: pointer;\n"])), (0,stereo_ui_styles_build_esm.getBackgroundColor)('transparent'));
var RoundedButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 12px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/components/AttachReviewMedia/AttachReviewMedia.js













var AttachReviewMedia = function AttachReviewMedia(_ref) {
  var selectedMedia = _ref.selectedMedia,
    setSelectedMedia = _ref.setSelectedMedia,
    structure = _ref.structure;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var refs = {
    fileInputPhotoRef: (0,react.useRef)(null),
    fileInputVideoRef: (0,react.useRef)(null)
  };
  var shouldDisableAttachment = function shouldDisableAttachment(mediaType) {
    var mediaList = selectedMedia.shownMedia.filter(function (item) {
      return item.type === mediaType;
    });
    var mediaQtd = mediaType === 'image' ? MAX_IMG_QTD : MAX_VIDEO_QTD;
    return mediaList.length >= mediaQtd;
  };
  var updateErrors = function updateErrors(key, error) {
    setErrors(function (prevErrors) {
      var newErrors = (0,esm_extends/* default */.Z)({}, prevErrors, error);
      if (!error) {
        delete newErrors[key];
      }
      return newErrors;
    });
  };
  var validateMedia = function validateMedia(id, value) {
    var error = value ? (0,defineProperty/* default */.Z)({}, id, value) : undefined;
    updateErrors(id, error);
  };
  var clearErrors = function clearErrors() {
    validateMedia('fileInputPhotoRef', undefined);
    validateMedia('fileInputVideoRef', undefined);
  };
  var verifyMediaFile = function verifyMediaFile(fileType, fileSize, mediaCount) {
    if (fileType === 'image') {
      if (mediaCount > MAX_IMG_QTD) {
        validateMedia('fileInputPhotoRef', msgErrorImgQtd);
      } else if (fileSize > MAX_IMG_SIZE) {
        validateMedia('fileInputPhotoRef', msgErrorImgSize);
      }
    }
    if (fileType === 'video') {
      if (mediaCount > MAX_VIDEO_QTD) {
        validateMedia('fileInputVideoRef', msgErrorVideoQtd);
      } else if (fileSize > MAX_VIDEO_SIZE) {
        validateMedia('fileInputVideoRef', msgErrorVideoSize);
      }
    }
  };
  var verifyMediaSize = function verifyMediaSize(fileType, fileSize) {
    return fileSize <= (fileType === 'image' ? MAX_IMG_SIZE : MAX_VIDEO_SIZE);
  };
  var verifyMediaExtension = function verifyMediaExtension(fileExtension) {
    return ALLOWED_IMG_EXT.includes(fileExtension) || ALLOWED_VIDEO_EXT.includes(fileExtension);
  };
  var verifyFileType = function verifyFileType(attachedFileType, fileType) {
    return attachedFileType === fileType && ALLOWED_FILE_TYPES.includes(fileType);
  };
  var verifyIsValidFile = function verifyIsValidFile(attachedFileType, fileType, fileExtension, fileNameExtension) {
    var isValidExtension = function isValidExtension(extension) {
      return ALLOWED_IMG_EXT.includes(extension) || ALLOWED_VIDEO_EXT.includes(extension);
    };
    return attachedFileType === fileType && isValidExtension(fileNameExtension) && isValidExtension(fileExtension);
  };
  var handleMediaType = function handleMediaType(fileType, file) {
    var reader = new FileReader();
    reader.onloadend = function () {
      setSelectedMedia(function (prevMedia) {
        return {
          attachedMedia: [].concat((0,toConsumableArray/* default */.Z)(prevMedia.attachedMedia), [file]),
          shownMedia: [].concat((0,toConsumableArray/* default */.Z)(prevMedia.shownMedia), [{
            type: fileType,
            url: reader.result
          }])
        };
      });
    };
    reader.readAsDataURL(file);
  };
  var handleMediaChange = function handleMediaChange(event, attachedFileType) {
    clearErrors();
    var counterImage = selectedMedia.shownMedia.filter(function (elem) {
      return elem.type === 'image';
    }).length;
    var counterVideo = selectedMedia.shownMedia.filter(function (elem) {
      return elem.type === 'video';
    }).length;
    (0,toConsumableArray/* default */.Z)(event.target.files).forEach(function (file) {
      var _file$name$split$pop;
      var fileNameExtension = (_file$name$split$pop = file.name.split('.').pop()) == null ? void 0 : _file$name$split$pop.toLowerCase();
      var _file$type$split = file.type.split('/'),
        _file$type$split2 = (0,slicedToArray/* default */.Z)(_file$type$split, 2),
        fileType = _file$type$split2[0],
        fileExtension = _file$type$split2[1];
      var fileSize = file.size;
      if (fileType === 'image') {
        counterImage += 1;
      }
      if (fileType === 'video') {
        counterVideo += 1;
      }
      var isValidFile = verifyIsValidFile(attachedFileType, fileType, fileExtension, fileNameExtension);
      if (isValidFile) {
        verifyMediaFile(fileType, fileSize, fileType === 'image' ? counterImage : counterVideo);
        var isValidFileType = verifyFileType(attachedFileType, fileType);
        var isValidFileExtension = verifyMediaExtension(fileExtension);
        var isValidMediaSize = verifyMediaSize(fileType, fileSize);
        var isValidMediaQtd = counterImage <= MAX_IMG_QTD && counterVideo <= MAX_VIDEO_QTD;
        if (isValidFileType && isValidFileExtension && isValidMediaSize && isValidMediaQtd) {
          clearErrors();
          handleMediaType(fileType, file);
        }
      } else {
        validateMedia('fileInputPhotoRef', msgErrorGeneral);
      }
    });
  };
  var renderAttachmentAlertMessage = function renderAttachmentAlertMessage(message) {
    return react.createElement(Flex/* default */.Z, {
      mt: 3,
      gap: "8px",
      alignItems: "center"
    }, react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
      name: "InfoCircle",
      width: 20,
      height: 20,
      color: "alert.danger.text"
    }), react.createElement(Text/* default */.Z, {
      lineHeight: "fontSize",
      fontWeight: "regular",
      fontSize: [1, 3],
      color: "alert.danger.text"
    }, message));
  };
  var handleButtonMediaClick = function handleButtonMediaClick(event, mediaType) {
    event.preventDefault();
    if (mediaType === 'video') {
      var _refs$fileInputVideoR, _refs$fileInputVideoR2;
      publish('product:reviewform:attachimage:click', {
        structure: structure
      });
      (_refs$fileInputVideoR = refs.fileInputVideoRef) == null ? void 0 : (_refs$fileInputVideoR2 = _refs$fileInputVideoR.current) == null ? void 0 : _refs$fileInputVideoR2.click();
    } else {
      var _refs$fileInputPhotoR, _refs$fileInputPhotoR2;
      publish('product:reviewform:attachimage:click', {
        structure: structure
      });
      (_refs$fileInputPhotoR = refs.fileInputPhotoRef) == null ? void 0 : (_refs$fileInputPhotoR2 = _refs$fileInputPhotoR.current) == null ? void 0 : _refs$fileInputPhotoR2.click();
    }
  };
  var handleRemovePhotoRef = function handleRemovePhotoRef() {
    refs.fileInputPhotoRef.current.value = '';
    refs.fileInputPhotoRef.current.type = 'file';
  };
  var handleRemoveVideoRef = function handleRemoveVideoRef() {
    refs.fileInputVideoRef.current.value = '';
    refs.fileInputVideoRef.current.type = 'file';
  };
  var handleRemoveMedia = function handleRemoveMedia(event, index) {
    event.preventDefault();
    setSelectedMedia(function (prevMedias) {
      return {
        attachedMedia: prevMedias.attachedMedia.filter(function (_, i) {
          return i !== index;
        }),
        shownMedia: prevMedias.shownMedia.filter(function (_, i) {
          return i !== index;
        })
      };
    });
    handleRemovePhotoRef();
    handleRemoveVideoRef();
    clearErrors();
  };
  return react.createElement(react.Fragment, null, react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    mt: 4
  }, react.createElement(Text/* default */.Z, {
    lineHeight: "fontSize",
    fontWeight: "medium",
    fontSize: [3, 5]
  }, "Compartilhe fotos do seu produto"), react.createElement(Text/* default */.Z, {
    lineHeight: "fontSize",
    fontWeight: "regular",
    fontSize: [2, 4],
    m: "24px 0"
  }, "Ao compartilhar fotos ou v\xEDdeos voc\xEA ajuda outras pessoas na decis\xE3o de compra."), react.createElement(Text/* default */.Z, {
    lineHeight: "fontSize",
    fontWeight: "regular",
    fontSize: [1, 3]
  }, "Voc\xEA pode enviar at\xE9 duas fotos com tamanho m\xE1ximo de 10MB e 1 v\xEDdeo de at\xE9 100MB.")), react.createElement(react.Fragment, null, react.createElement(Input/* default */.Z, {
    id: "image-upload",
    type: "file",
    accept: "image/*",
    ref: refs.fileInputPhotoRef,
    style: {
      display: 'none'
    },
    onChange: function onChange(event) {
      return handleMediaChange(event, ALLOWED_FILE_TYPES[0]);
    },
    multiple: true,
    "data-testid": "upload-img"
  }), react.createElement(Input/* default */.Z, {
    id: "video-upload",
    type: "file",
    accept: "video/*",
    ref: refs.fileInputVideoRef,
    style: {
      display: 'none'
    },
    onChange: function onChange(event) {
      return handleMediaChange(event, ALLOWED_FILE_TYPES[1]);
    },
    multiple: true,
    "data-testid": "upload-video"
  }), selectedMedia.shownMedia.length > 0 && react.createElement(AttachmentGaleryContainer, null, react.createElement(AttachmentGaleryList, null, selectedMedia.shownMedia.map(function (media, index) {
    return react.createElement(AttachmentGaleryItem, {
      key: "attached-item-".concat(index + 1)
    }, media.type === 'image' ? react.createElement(AttachedImage, {
      id: "photo-uploader",
      src: media.url,
      alt: "selected image ".concat(index + 1)
    }) : react.createElement(AttachedVideo, {
      "data-testid": "video-uploader-".concat(index + 1),
      src: media.url,
      controls: true
    }), react.createElement(DeleteAttachment, {
      "aria-label": "remove-item-".concat(index),
      onClick: function onClick(event) {
        return handleRemoveMedia(event, index);
      }
    }, react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
      name: "Close",
      width: 20,
      height: 20
    })));
  }))), errors.fileInputPhotoRef && renderAttachmentAlertMessage(errors.fileInputPhotoRef), errors.fileInputVideoRef && renderAttachmentAlertMessage(errors.fileInputVideoRef)), react.createElement(Flex/* default */.Z, {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: ['100%'],
    mt: "12px"
  }, react.createElement(RoundedButton, {
    full: true,
    centered: true,
    size: "large",
    uppercase: false,
    m: "16px 0",
    variation: "outline",
    maxWidth: "568px",
    "data-testid": "button-submit-photo",
    htmlFor: "image-upload",
    onClick: function onClick(event) {
      return handleButtonMediaClick(event, 'image');
    },
    disabled: shouldDisableAttachment('image'),
    startIcon: react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
      name: "CategoryCF"
    })
  }, "Enviar foto"), react.createElement(RoundedButton, {
    full: true,
    centered: true,
    size: "large",
    uppercase: false,
    variation: "outline",
    maxWidth: "568px",
    "data-testid": "button-submit-video",
    htmlFor: "video-upload",
    onClick: function onClick(event) {
      handleButtonMediaClick(event, 'video');
    },
    disabled: shouldDisableAttachment('video'),
    startIcon: react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
      name: "CategoryFM"
    })
  }, "Enviar v\xEDdeo")));
};
 false ? 0 : void 0;
AttachReviewMedia.defaultProps = {
  structure: {}
};
/* harmony default export */ var AttachReviewMedia_AttachReviewMedia = (AttachReviewMedia);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/components/AttachReviewMedia/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/components/RatingComment/RatingComment.js


var _excluded = ["error", "onChange", "rating", "value"];




var RatingComment = (0,react.forwardRef)(function (_ref, ref) {
  var error = _ref.error,
    onChange = _ref.onChange,
    rating = _ref.rating,
    value = _ref.value,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  return react.createElement(atoms/* Flex */.kC, {
    maxWidth: "568px",
    flexDirection: "column",
    ref: ref,
    "data-testid": "rating-comment"
  }, react.createElement(atoms/* Text */.xv, {
    mb: [3, 4],
    "data-testid": "rating-comment-label",
    lineHeight: "input",
    fontWeight: "medium",
    fontSize: [2, 5]
  }, "O que os clientes precisam saber antes de comprar?", rating > 3 && react.createElement(atoms/* Text */.xv, {
    ml: [1, 0],
    as: "span",
    fontWeight: "regular",
    color: "lighter",
    fontSize: [1, 4]
  }, "Opcional")), react.createElement(atoms/* Input */.II, (0,esm_extends/* default */.Z)({}, props, {
    "data-testid": "rating-comment-input",
    multiline: true,
    rows: "6",
    onChange: onChange,
    placeholder: "O que voc\xEA gostou e o que n\xE3o gostou no produto?",
    value: value
  })), !error.valid && react.createElement(atoms/* Flex */.kC, {
    mt: 3,
    alignItems: "center",
    gap: 2,
    "data-testid": "rating-comment-error",
    role: "alert"
  }, react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    name: "InfoCircle",
    color: "alert.danger.text",
    width: 20,
    height: 20
  }), react.createElement(atoms/* Text */.xv, {
    fontSize: [1, 2],
    color: "alert.danger.text"
  }, error.message)), error.valid && react.createElement(atoms/* Flex */.kC, {
    mt: 3,
    alignItems: "center",
    gap: 2,
    "data-testid": "rating-comment-notification",
    role: "alert"
  }, react.createElement(atoms/* Text */.xv, {
    fontSize: [1, 2],
    color: error.textColor
  }, error.message)));
});
RatingComment.displayName = 'RatingInput';
RatingComment.defaultProps = {
  error: {
    message: '',
    valid: true
  },
  onChange: function onChange() {},
  rating: 0,
  value: ''
};
 false ? 0 : void 0;
/* harmony default export */ var RatingComment_RatingComment = (RatingComment);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/components/RatingComment/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/components/RatingInput/RatingInput.js


var RatingInput_excluded = ["label", "variant", "error"];




var RatingInput = (0,react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
    variant = _ref.variant,
    error = _ref.error,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, RatingInput_excluded);
  var variants = {
    "default": {
      alignItems: 'center',
      flexDirection: 'row',
      fontSize: [2, 4],
      fontWeight: 'regular',
      gap: [3, 4],
      iconSize: [24, 40]
    },
    large: {
      alignItems: ['flex-start', 'center'],
      flexDirection: ['column', 'row'],
      fontSize: [3, 5],
      fontWeight: 'medium',
      gap: [3, 0],
      iconSize: [40, 48]
    }
  };
  var _variants$variant = variants[variant],
    alignItems = _variants$variant.alignItems,
    flexDirection = _variants$variant.flexDirection,
    fontSize = _variants$variant.fontSize,
    fontWeight = _variants$variant.fontWeight,
    gap = _variants$variant.gap,
    iconSize = _variants$variant.iconSize;
  return react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    ref: ref,
    "data-testid": "rating-input"
  }, react.createElement(atoms/* Flex */.kC, {
    width: 1,
    justifyContent: "space-between",
    alignItems: alignItems,
    flexDirection: flexDirection,
    gap: gap
  }, react.createElement(atoms/* Text */.xv, {
    lineHeight: "fontSize",
    fontSize: fontSize,
    fontWeight: fontWeight,
    "data-testid": "rating-input-label"
  }, label), react.createElement(atoms/* SelectRating */.jv, (0,esm_extends/* default */.Z)({
    height: iconSize,
    width: iconSize,
    emptyOutline: true,
    "data-testid": "rating-input-stars"
  }, props))), error && react.createElement(atoms/* Flex */.kC, {
    mt: 1,
    alignItems: "center",
    gap: 2,
    "data-testid": "rating-input-error",
    role: "alert"
  }, react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    name: "InfoCircle",
    color: "alert.danger.text",
    width: [13, 20],
    height: [13, 20]
  }), react.createElement(atoms/* Text */.xv, {
    fontSize: [1, 2],
    color: "alert.danger.text"
  }, error)));
});
RatingInput.displayName = 'RatingInput';
RatingInput.defaultProps = {
  error: '',
  label: '',
  variant: 'default'
};
 false ? 0 : void 0;
/* harmony default export */ var RatingInput_RatingInput = (RatingInput);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/components/RatingInput/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/ProductReviewForm.js






function ProductReviewForm_regeneratorRuntime() { "use strict"; ProductReviewForm_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }















var ProductReviewForm = function ProductReviewForm(_ref) {
  var _data$product, _data$product$seller, _structure$route, _structure$config, _structure$config$rev, _data$product2, _data$product2$seller, _data$product3, _data$categoryDimensi;
  var data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var channel = staticProps.channel;
  var sku = (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$seller = _data$product.seller) == null ? void 0 : _data$product$seller.sku) || (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId) || '';
  var isEnableSeller = (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : (_structure$config$rev = _structure$config.review) == null ? void 0 : _structure$config$rev.toogleEnableSellerId) === (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$seller = _data$product2.seller) == null ? void 0 : _data$product2$seller.id);
  var productImageUrl = (data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.image) || '';
  var _useState = (0,react.useState)(0),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    rating = _useState2[0],
    setRating = _useState2[1];
  var _useState3 = (0,react.useState)({}),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var _useState5 = (0,react.useState)(''),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    statusMessage = _useState6[0],
    setStatusMessage = _useState6[1];
  var _useState7 = (0,react.useState)((data == null ? void 0 : (_data$categoryDimensi = data.categoryDimensions) == null ? void 0 : _data$categoryDimensi.dimensions) || []),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    dimensionsRating = _useState8[0],
    setDimensionsRating = _useState8[1];
  var _useState9 = (0,react.useState)(''),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    comment = _useState10[0],
    setComment = _useState10[1];
  var _useState11 = (0,react.useState)({
      attachedMedia: [],
      shownMedia: []
    }),
    _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
    selectedMedia = _useState12[0],
    setSelectedMedia = _useState12[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var setLoading = function setLoading(loading) {
    return publish('page:loading', loading);
  };
  var _useReview = (0,esm.useReview)(),
    createUserReviewSubmission = _useReview.createUserReviewSubmission;
  var refs = (0,esm_extends/* default */.Z)({
    comment: (0,react.useRef)(null),
    rating: (0,react.useRef)(null)
  }, dimensionsRating == null ? void 0 : dimensionsRating.reduce(function (acc, _ref2) {
    var id = _ref2.id;
    return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, id, (0,react.useRef)(null)));
  }, {}));
  var changeDimensionsRating = function changeDimensionsRating(e, id) {
    setDimensionsRating(function (prevDimensions) {
      return prevDimensions == null ? void 0 : prevDimensions.map(function (dimension) {
        return dimension.id === id ? (0,esm_extends/* default */.Z)({}, dimension, {
          value: e.target.value
        }) : dimension;
      });
    });
  };
  var updateErrors = function updateErrors(key, error) {
    setErrors(function (prevErrors) {
      var newErrors = (0,esm_extends/* default */.Z)({}, prevErrors, error);
      if (!error) {
        delete newErrors[key];
      }
      if (typeof window !== 'undefined' && window.focus && newErrors[key]) {
        var current = refs[key].current;
        current == null ? void 0 : current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      return newErrors;
    });
  };
  var validateComment = function validateComment(id, value) {
    var inputValidation = (0,hooks/* useReviewInputValidation */.tk)(value, rating);
    var error = (!(inputValidation == null ? void 0 : inputValidation.valid) || (inputValidation == null ? void 0 : inputValidation.textColor) === 'text.light') && (0,defineProperty/* default */.Z)({}, id, inputValidation);
    updateErrors(id, error);
    return error;
  };
  var validateRating = function validateRating(id, value) {
    var error = !value ? (0,defineProperty/* default */.Z)({}, id, 'Clique nas estrelas para classificar o produto') : undefined;
    updateErrors(id, error);
    return error;
  };
  var clearForm = function clearForm() {
    var _data$categoryDimensi2;
    setRating(0);
    setComment('');
    setDimensionsRating((data == null ? void 0 : (_data$categoryDimensi2 = data.categoryDimensions) == null ? void 0 : _data$categoryDimensi2.dimensions) || []);
    setSelectedMedia({
      attachedMedia: [],
      shownMedia: []
    });
  };
  var handleSendReview = function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(ProductReviewForm_regeneratorRuntime().mark(function _callee(userDataHandler, medias) {
      var _structure$config2, _structure$config3, _structure$query, _data$product4, _data$product5, _data$product6, _data$product6$seller, _structure$route2, _result$createUserRev;
      var images, videos, basePath, _yield$createUserRevi, result;
      return ProductReviewForm_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            images = [];
            videos = [];
            basePath = (structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.desktopSiteDomain) || (structure == null ? void 0 : (_structure$config3 = structure.config) == null ? void 0 : _structure$config3.canonicalDomain);
            medias == null ? void 0 : medias.forEach(function (elem) {
              if (elem.mediaType === 'video') {
                videos.push(elem.mediaId);
              } else {
                images.push(elem.mediaId);
              }
            });
            _context.next = 6;
            return createUserReviewSubmission({
              request: (0,esm_extends/* default */.Z)({
                campaignId: !((_structure$query = structure.query) == null ? void 0 : _structure$query.rd) ? '' : 'CRM',
                channel: channel,
                description: comment,
                dimensions: dimensionsRating == null ? void 0 : dimensionsRating.map(function (_ref6) {
                  var id = _ref6.id,
                    value = _ref6.value,
                    label = _ref6.label;
                  return {
                    id: id,
                    label: label,
                    rating: value
                  };
                }),
                product: {
                  images: images,
                  productImageUrl: productImageUrl,
                  productLink: "".concat(basePath, "/").concat(data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.path),
                  productName: data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : _data$product5.title,
                  ratingValue: rating.toString(),
                  sku: sku,
                  videos: videos
                },
                rating: rating
              }, userDataHandler, {
                sellerId: data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : (_data$product6$seller = _data$product6.seller) == null ? void 0 : _data$product6$seller.id,
                variationId: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.productId
              })
            }, {
              timeout: 8000
            });
          case 6:
            _yield$createUserRevi = _context.sent;
            result = _yield$createUserRevi.data;
            publish('product:reviewform:submit', comment, rating);
            setStatusMessage(result);
            publish('review:modal:open');
            if ((result == null ? void 0 : (_result$createUserRev = result.createUserReviewSubmission) == null ? void 0 : _result$createUserRev.status) === 'SUCCESS') {
              clearForm();
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSendReview(_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var uploadMedia = function uploadMedia(userDataHandler) {
    var _data$product7, _data$product7$seller, _structure$config4, _userDataHandler$user, _structure$cookies, _structure$cookies$ac;
    var headers = {
      'marketplace-id': 'Magalu-Mktplace',
      'seller-id': data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$seller = _data$product7.seller) == null ? void 0 : _data$product7$seller.id,
      sku: sku
    };
    var attachedMedia = selectedMedia.attachedMedia;
    var uploadedMedias = [];
    setLoading(true);
    var customerId = (structure == null ? void 0 : (_structure$config4 = structure.config) == null ? void 0 : _structure$config4.isMiniApp) ? (_userDataHandler$user = userDataHandler.userData) == null ? void 0 : _userDataHandler$user.customerId : structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id;
    attachedMedia.forEach(function (elem) {
      return Promise.all([uploadMediaReview(headers, elem, structure, customerId)]).then(function (response) {
        uploadedMedias.push.apply(uploadedMedias, (0,toConsumableArray/* default */.Z)(response));
        if (uploadedMedias.length === attachedMedia.length) {
          setLoading(false);
          handleSendReview(userDataHandler, uploadedMedias);
        }
      })["catch"](function () {
        var errorReturn = {
          createUserReviewSubmission: {
            description: 'Não foi possível enviar os arquivos. Tente novamente em alguns instantes!',
            msg: 'Erro ao fazer o envio de fotos e vídeos!',
            status: 'ERROR'
          }
        };
        setLoading(false);
        setStatusMessage(errorReturn);
        publish('review:modal:open');
      });
    });
  };
  var handleSubmit = function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)(ProductReviewForm_regeneratorRuntime().mark(function _callee2(e) {
      var errorsValidation, _structure$query2, _structure$config5, _structure$config5$re, user, userDataHandler, _structure$query3, shouldAttachMedia;
      return ProductReviewForm_regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            errorsValidation = (0,esm_extends/* default */.Z)({}, validateRating('rating', rating), dimensionsRating.reduce(function (acc, _ref8) {
              var id = _ref8.id,
                value = _ref8.value;
              return (0,esm_extends/* default */.Z)({}, acc, validateRating(id, value));
            }, {}), Object.entries(validateComment('comment', comment)).filter(function (_ref9) {
              var _ref10 = (0,slicedToArray/* default */.Z)(_ref9, 2),
                value = _ref10[1];
              return value.valid !== true;
            }));
            if (Object.keys(errorsValidation).length) {
              _context2.next = 10;
              break;
            }
            _context2.next = 5;
            return (0,useUserData/* default */.Z)({
              structure: structure
            });
          case 5:
            user = _context2.sent;
            userDataHandler = null;
            if (structure == null ? void 0 : (_structure$query2 = structure.query) == null ? void 0 : _structure$query2.rd) {
              userDataHandler = {
                userDataJWT: structure == null ? void 0 : (_structure$query3 = structure.query) == null ? void 0 : _structure$query3.rd
              };
            } else {
              userDataHandler = {
                userData: {
                  customerId: user.id,
                  email: user.email,
                  name: user.name
                }
              };
            }
            shouldAttachMedia = ((structure == null ? void 0 : (_structure$config5 = structure.config) == null ? void 0 : (_structure$config5$re = _structure$config5.review) == null ? void 0 : _structure$config5$re.toggleEnableAttachMedia) || isEnableSeller) && selectedMedia.attachedMedia.length > 0;
            if (shouldAttachMedia) {
              uploadMedia(userDataHandler);
            } else {
              handleSendReview(userDataHandler);
            }
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  var handleComment = function handleComment(e) {
    validateComment('comment', e.target.value);
    setComment(e.target.value);
  };
  var renderAttachMediaBlock = function renderAttachMediaBlock() {
    var _structure$config6, _structure$config6$re;
    return ((structure == null ? void 0 : (_structure$config6 = structure.config) == null ? void 0 : (_structure$config6$re = _structure$config6.review) == null ? void 0 : _structure$config6$re.toggleEnableAttachMedia) || isEnableSeller) && react.createElement(AttachReviewMedia_AttachReviewMedia, {
      selectedMedia: selectedMedia,
      setSelectedMedia: setSelectedMedia
    });
  };
  return react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    as: "form",
    onSubmit: handleSubmit
  }, react.createElement(RatingInput_RatingInput, {
    label: "O que voc\xEA achou desse produto?",
    variant: "large",
    showLabel: true,
    value: rating,
    error: errors.rating,
    onChange: function onChange(e) {
      validateRating('rating', e.target.value);
      setRating(e.target.value);
    },
    name: "rating",
    ref: refs.rating
  }), react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    mt: 4,
    gap: "24px",
    pr: [0, 80]
  }, dimensionsRating.length > 0 && react.createElement(atoms/* Text */.xv, {
    lineHeight: "fontSize",
    fontWeight: "medium",
    fontSize: [3, 5]
  }, "Como voc\xEA avalia as caracter\xEDsticas abaixo?"), dimensionsRating == null ? void 0 : dimensionsRating.map(function (_ref11) {
    var id = _ref11.id,
      label = _ref11.label,
      value = _ref11.value;
    return react.createElement(RatingInput_RatingInput, {
      key: id,
      label: label,
      showLabel: false,
      value: value,
      onChange: function onChange(e) {
        validateRating(id, e.target.value);
        changeDimensionsRating(e, id);
      },
      name: id,
      error: errors[id],
      ref: refs[id]
    });
  })), renderAttachMediaBlock(), react.createElement(atoms/* Flex */.kC, {
    mt: "32px"
  }, react.createElement(RatingComment_RatingComment, {
    ref: refs.comment,
    error: errors.comment,
    rating: rating,
    onChange: function onChange(e) {
      handleComment(e);
    },
    value: comment,
    maxLength: MAX_COMMENT_LENGTH
  })), react.createElement(RoundedButton, {
    size: "large",
    full: true,
    uppercase: false,
    mt: 32,
    mb: [32, 80],
    variation: "outline",
    maxWidth: "568px",
    type: "submit",
    "data-testid": "button-submit"
  }, "Enviar Avalia\xE7\xE3o"), react.createElement(ReviewModal/* default */.Z, {
    data: data,
    structure: structure,
    variant: statusMessage,
    "static": staticProps
  }));
};
 false ? 0 : void 0;
ProductReviewForm.defaultProps = {
  data: {
    categoryDimensions: {
      dimensions: []
    }
  },
  "static": {},
  structure: {}
};
ProductReviewForm.ssr = false;
/* harmony default export */ var ProductReviewForm_ProductReviewForm = ((0,withLayoutProps/* default */.Z)(ProductReviewForm));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewForm/index.js


/***/ }),

/***/ 62739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductReviewInfo_ProductReviewInfo; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewInfo/ProductReviewInfo.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4;




var Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    bg: 'background.lighter',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    flexDirection: 'column',
    my: [24, 18]
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 320px;\n"])));
var Image = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n  height: 152px;\n  width: 216px;\n"])));
var TextContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    flexDirection: 'column'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 3,
    fontStyle: 'normal',
    fontWeight: 'normal',
    maxWidth: '100%',
    mt: 3,
    textAlign: 'left'
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 24px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewInfo/ProductReviewInfo.js






var ProductReviewInfo = function ProductReviewInfo(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var _ref2 = (data == null ? void 0 : data.product) || {},
    image = _ref2.image,
    title = _ref2.title;
  var link = staticProps.link;
  var handleClickLink = function handleClickLink(e) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: link,
      spa: true
    });
  };
  return react.createElement(Container, {
    "data-testid": "product-evaluation-container"
  }, react.createElement(Link/* default */.Z, {
    "data-testid": "product-evaluation-pdp-link",
    href: link,
    onClick: handleClickLink,
    flexDirection: "column"
  }, react.createElement(Image, {
    src: image,
    alt: title,
    "data-testid": "product-evaluation-img"
  }), react.createElement(TextContainer, {
    "data-testid": "product-evaluation-section"
  }, react.createElement(Title, {
    color: "black",
    lineHeight: "display",
    "data-testid": "product-evaluation-title"
  }, title))));
};
ProductReviewInfo.defaultProps = {
  data: {},
  "static": {
    link: ''
  }
};
 false ? 0 : void 0;
ProductReviewInfo.ssr = true;
/* harmony default export */ var ProductReviewInfo_ProductReviewInfo = ((0,withLayoutProps/* default */.Z)(ProductReviewInfo));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewInfo/index.js


/***/ }),

/***/ 48269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductReviewInfoBasic_ProductReviewInfoBasic; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewInfoBasic/ProductReviewInfoBasic.styles.js


var _templateObject, _templateObject2, _templateObject3;




var Image = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100px;\n  width: 100px;\n  border-radius: 8px;\n"])));
var TextContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    flexDirection: 'column',
    lineHeight: '22px'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 16px;\n  padding-top: 8px;\n"])));
var Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: block;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewInfoBasic/ProductReviewInfoBasic.js






var ProductReviewInfoBasic = function ProductReviewInfoBasic(_ref) {
  var _data$product;
  var data = _ref.data,
    staticProps = _ref["static"];
  var link = staticProps.link,
    linkTitle = staticProps.linkTitle;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    image = _ref2.image,
    title = _ref2.title;
  var handleClickLinkInformation = function handleClickLinkInformation(e) {
    e.preventDefault();
    if (link) {
      (0,esm/* routePush */.dY)({
        path: link,
        spa: true
      });
    }
  };
  return react.createElement(atoms/* Flex */.kC, {
    bg: "background.darker",
    p: 3,
    "data-testid": "product-evaluation-container"
  }, !!(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.title) && react.createElement(atoms/* Link */.rU, {
    href: link,
    "data-testid": "product-evaluation-content",
    onClick: handleClickLinkInformation
  }, react.createElement(Image, {
    src: image,
    alt: title,
    "data-testid": "product-evaluation-img"
  }), react.createElement(TextContainer, {
    "data-testid": "product-evaluation-section"
  }, react.createElement(Heading/* default */.Z, {
    as: "h1",
    fontSize: 3,
    fontStyle: "normal",
    fontWeight: "medium",
    textAlign: "left",
    color: "text.base",
    "data-testid": "product-evaluation-title"
  }, react.createElement(Title, {
    as: "span",
    "data-testid": "product-evaluation-title-link"
  }, linkTitle), title))));
};
ProductReviewInfoBasic.defaultProps = {
  data: {},
  "static": {
    label: '',
    linkTitle: ''
  }
};
 false ? 0 : void 0;
ProductReviewInfoBasic.ssr = true;
/* harmony default export */ var ProductReviewInfoBasic_ProductReviewInfoBasic = (ProductReviewInfoBasic);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewInfoBasic/index.js


/***/ }),

/***/ 80903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ProductReviewMediaCarousel_ProductReviewMediaCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/index.js + 3 modules
var ProductReviewGallery = __webpack_require__(99970);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/index.js + 11 modules
var ProductReviewPopup = __webpack_require__(77576);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/index.js + 2 modules
var MediaReviewCard = __webpack_require__(97949);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewMediaCarousel/ProductReviewMediaCarousel.styles.js

var _templateObject, _templateObject2, _templateObject3;



var ProductReviewCard = (0,styled_components_browser_esm["default"])(MediaReviewCard/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var ProductReviewContainer = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 16px 0;\n"])));
var ProductReviewRating = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  width: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewMediaCarousel/utils.js

var extractItemId = function extractItemId(mediaUrl) {
  var _mediaUrl$split$rever = mediaUrl.split('/').reverse()[0].split('.'),
    _mediaUrl$split$rever2 = (0,slicedToArray/* default */.Z)(_mediaUrl$split$rever, 1),
    itemId = _mediaUrl$split$rever2[0];
  return itemId;
};
var handleMediaClick = function handleMediaClick(mediaProps, key, publish) {
  var processedMedia = mediaProps.filter(function (media) {
    return media.processed;
  });
  var selectedMedia = processedMedia[key];
  if (selectedMedia.mediaType === 'image') {
    publish('product:review:condensedMedia:image:click');
  } else {
    publish('product:review:condensedMedia:video:click');
  }
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewMediaCarousel/ProductReviewMediaCarousel.js












var ProductReviewMediaCarousel = function ProductReviewMediaCarousel(_ref) {
  var _data$productRating, _data$productRating$u;
  var data = _ref.data,
    staticProps = _ref["static"];
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isPopupOpen = _useState2[0],
    setIsPopupOpen = _useState2[1];
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    selectedMedia = _useState4[0],
    setSelectedMedia = _useState4[1];
  var _useState5 = (0,react.useState)(null),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    review = _useState6[0],
    setReview = _useState6[1];
  var items = (data == null ? void 0 : (_data$productRating = data.productRating) == null ? void 0 : (_data$productRating$u = _data$productRating.userReviews) == null ? void 0 : _data$productRating$u.items) || [];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var isMobile = staticProps.isMobile;
  var mountCondensedReview = function mountCondensedReview() {
    var reviews = [];
    var mediaProps = [];
    items.forEach(function (item) {
      var _item$product, _item$product2;
      var images = (item == null ? void 0 : (_item$product = item.product) == null ? void 0 : _item$product.images) || [];
      var videos = (item == null ? void 0 : (_item$product2 = item.product) == null ? void 0 : _item$product2.videos) || [];
      var medias = images.concat(videos);
      medias == null ? void 0 : medias.forEach(function (media) {
        var mediaPayload = {
          mediaType: media.includes('video') ? 'video' : 'image',
          mediaUrl: media,
          processed: media.includes('processed'),
          thumbnails: media.includes('thumbnails')
        };
        mediaProps.push(mediaPayload);
        var payload = {
          mediaProps: mediaPayload,
          product: (0,esm_extends/* default */.Z)({}, media.includes('image') && {
            image: media
          }, media.includes('video') && {
            video: media
          }),
          review: {
            attributes: item.attributes,
            description: item.description,
            rating: item.rating,
            submissionDate: item.submissionDate,
            userData: item.userData
          }
        };
        reviews.push(payload);
      });
    });
    return {
      mediaProps: mediaProps,
      reviews: reviews
    };
  };
  var renderGallery = function renderGallery(thumbnails, _onClick) {
    return react.createElement(ProductReviewGallery/* default */.Z, {
      isMobile: isMobile
    }, thumbnails.map(function (elem, key) {
      return react.createElement(ProductReviewCard, {
        key: "product-review-".concat(extractItemId(elem.mediaProps.mediaUrl)),
        onClick: function onClick() {
          return _onClick(key);
        },
        "data-testid": "product-review-card",
        media: {
          mediaType: elem.mediaProps.mediaUrl.includes('video') ? 'video' : 'image',
          mediaUrl: elem.mediaProps.mediaUrl
        },
        width: "121px",
        height: "162px"
      }, react.createElement(ProductReviewRating, null, react.createElement(esm/* Star */.Uxw, {
        color: "text.white",
        height: 18,
        width: 18
      }), react.createElement(atoms/* Text */.xv, {
        ml: "8px",
        color: "text.white",
        fontWeight: "bold"
      }, elem.review.rating)));
    }));
  };
  var _mountCondensedReview = mountCondensedReview(),
    reviews = _mountCondensedReview.reviews,
    mediaProps = _mountCondensedReview.mediaProps;
  var thumbnails = reviews.filter(function (item) {
    return item.mediaProps.thumbnails;
  });
  var processed = reviews.filter(function (item) {
    return item.mediaProps.processed;
  });
  var handleClick = function handleClick(key) {
    setIsPopupOpen(true);
    setSelectedMedia(key);
    setReview(processed[key].review);
    handleMediaClick(mediaProps, key, publish);
  };
  var handleChange = function handleChange(item) {
    setReview(processed[item].review);
  };
  return react.createElement(ProductReviewContainer, null, renderGallery(thumbnails, handleClick), isPopupOpen && react.createElement(ProductReviewPopup/* default */.Z, {
    review: review,
    mediaProps: mediaProps,
    changeCaroulsel: function changeCaroulsel(item) {
      return handleChange(item);
    },
    charLimit: 120,
    selectedMedia: selectedMedia,
    closePopup: function closePopup() {
      return setIsPopupOpen(false);
    }
  }));
};
 false ? 0 : void 0;
ProductReviewMediaCarousel.defaultProps = {
  data: {
    productRating: {
      userReviews: {
        items: []
      }
    }
  },
  "static": {
    isMobile: false
  }
};
ProductReviewMediaCarousel.ssr = false;
/* harmony default export */ var ProductReviewMediaCarousel_ProductReviewMediaCarousel = ((0,withLayoutProps/* default */.Z)(ProductReviewMediaCarousel));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductReviewMediaCarousel/index.js


/***/ }),

/***/ 18714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductRichContent_ProductRichContent; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductRichContent/ProductRichContent.js






var iframeRegexp = /<iframe [^<]*(<\/iframe>|\/>)/g;
var removeNonIframeHtml = function removeNonIframeHtml(data) {
  var _data$match, _data$match$join;
  return ((_data$match = data.match(iframeRegexp)) == null ? void 0 : (_data$match$join = _data$match.join('')) == null ? void 0 : _data$match$join.replace(/http:\/\//g, 'https://')) || null;
};
var ProductRichContent = function ProductRichContent(_ref) {
  var data = _ref.data;
  var _useProductInfo = (0,hooks/* useProductInfo */.MW)(data == null ? void 0 : data.product),
    factsheet = _useProductInfo.factsheet;
  var richContent = removeNonIframeHtml((0,esm/* getFactsheetValueFromSlug */.l)(factsheet, 'destaques') || '');
  return !!richContent && react.createElement(Box/* default */.Z, {
    textAlign: "center",
    dangerouslySetInnerHTML: {
      __html: "".concat(richContent)
    }
  });
};
ProductRichContent.defaultProps = {
  data: {
    product: {}
  }
};
 false ? 0 : void 0;
ProductRichContent.dataSource = {
  product: {
    fragments: ['includeFactSheet']
  }
};
ProductRichContent.ssr = true;
/* harmony default export */ var ProductRichContent_ProductRichContent = ((0,withLayoutProps/* default */.Z)(ProductRichContent));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ProductRichContent/index.js


/***/ })

}]);